// https://unpkg.com/@oddbird/css-anchor-positioning@0.6.1/dist/css-anchor-positioning.js
var mo = Object.defineProperty, ko = Object.defineProperties;
var So = Object.getOwnPropertyDescriptors;
var vn = Object.getOwnPropertySymbols;
var yo = Object.prototype.hasOwnProperty, bo = Object.prototype.propertyIsEnumerable;
var En = (t, e, n) => e in t ? mo(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, W = (t, e) => {
  for (var n in e || (e = {}))
    yo.call(e, n) && En(t, n, e[n]);
  if (vn)
    for (var n of vn(e))
      bo.call(e, n) && En(t, n, e[n]);
  return t;
}, q = (t, e) => ko(t, So(e));
var xo = (t, e) => () => (e || t((e = { exports: {} }).exports, e), e.exports);
var R = (t, e, n) => new Promise((r, s) => {
  var o = (u) => {
    try {
      l(n.next(u));
    } catch (i) {
      s(i);
    }
  }, a = (u) => {
    try {
      l(n.throw(u));
    } catch (i) {
      s(i);
    }
  }, l = (u) => u.done ? r(u.value) : Promise.resolve(u.value).then(o, a);
  l((n = n.apply(t, e)).next());
});
var qp = xo((ue) => {
  const tn = Math.min, Vt = Math.max, we = Math.round, fe = Math.floor, kt = (t) => ({
    x: t,
    y: t
  });
  function Co(t, e) {
    return typeof t == "function" ? t(e) : t;
  }
  function wo(t) {
    return W({
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }, t);
  }
  function Ao(t) {
    return typeof t != "number" ? wo(t) : {
      top: t,
      right: t,
      bottom: t,
      left: t
    };
  }
  function Ae(t) {
    const {
      x: e,
      y: n,
      width: r,
      height: s
    } = t;
    return {
      width: r,
      height: s,
      top: n,
      left: e,
      right: e + r,
      bottom: n + s,
      x: e,
      y: n
    };
  }
  function To(t, e) {
    return R(this, null, function* () {
      var n;
      e === void 0 && (e = {});
      const {
        x: r,
        y: s,
        platform: o,
        rects: a,
        elements: l,
        strategy: u
      } = t, {
        boundary: i = "clippingAncestors",
        rootBoundary: c = "viewport",
        elementContext: h = "floating",
        altBoundary: f = !1,
        padding: p = 0
      } = Co(e, t), g = Ao(p), S = l[f ? h === "floating" ? "reference" : "floating" : h], b = Ae(yield o.getClippingRect({
        element: (n = yield o.isElement == null ? void 0 : o.isElement(S)) == null || n ? S : S.contextElement || (yield o.getDocumentElement == null ? void 0 : o.getDocumentElement(l.floating)),
        boundary: i,
        rootBoundary: c,
        strategy: u
      })), C = h === "floating" ? {
        x: r,
        y: s,
        width: a.floating.width,
        height: a.floating.height
      } : a.reference, v = yield o.getOffsetParent == null ? void 0 : o.getOffsetParent(l.floating), M = (yield o.isElement == null ? void 0 : o.isElement(v)) ? (yield o.getScale == null ? void 0 : o.getScale(v)) || {
        x: 1,
        y: 1
      } : {
        x: 1,
        y: 1
      }, k = Ae(o.convertOffsetParentRelativeRectToViewportRelativeRect ? yield o.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: l,
        rect: C,
        offsetParent: v,
        strategy: u
      }) : C);
      return {
        top: (b.top - k.top + g.top) / M.y,
        bottom: (k.bottom - b.bottom + g.bottom) / M.y,
        left: (b.left - k.left + g.left) / M.x,
        right: (k.right - b.right + g.right) / M.x
      };
    });
  }
  function Pe() {
    return typeof window != "undefined";
  }
  function Zt(t) {
    return Ir(t) ? (t.nodeName || "").toLowerCase() : "#document";
  }
  function st(t) {
    var e;
    return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
  }
  function yt(t) {
    var e;
    return (e = (Ir(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
  }
  function Ir(t) {
    return Pe() ? t instanceof Node || t instanceof st(t).Node : !1;
  }
  function lt(t) {
    return Pe() ? t instanceof Element || t instanceof st(t).Element : !1;
  }
  function St(t) {
    return Pe() ? t instanceof HTMLElement || t instanceof st(t).HTMLElement : !1;
  }
  function $n(t) {
    return !Pe() || typeof ShadowRoot == "undefined" ? !1 : t instanceof ShadowRoot || t instanceof st(t).ShadowRoot;
  }
  function ce(t) {
    const {
      overflow: e,
      overflowX: n,
      overflowY: r,
      display: s
    } = ct(t);
    return /auto|scroll|overlay|hidden|clip/.test(e + r + n) && !["inline", "contents"].includes(s);
  }
  function vo(t) {
    return ["table", "td", "th"].includes(Zt(t));
  }
  function Re(t) {
    return [":popover-open", ":modal"].some((e) => {
      try {
        return t.matches(e);
      } catch (n) {
        return !1;
      }
    });
  }
  function gn(t) {
    const e = mn(), n = lt(t) ? ct(t) : t;
    return ["transform", "translate", "scale", "rotate", "perspective"].some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !e && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !e && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
  }
  function Eo(t) {
    let e = Ot(t);
    for (; St(e) && !Kt(e); ) {
      if (gn(e))
        return e;
      if (Re(e))
        return null;
      e = Ot(e);
    }
    return null;
  }
  function mn() {
    return typeof CSS == "undefined" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
  }
  function Kt(t) {
    return ["html", "body", "#document"].includes(Zt(t));
  }
  function ct(t) {
    return st(t).getComputedStyle(t);
  }
  function Ie(t) {
    return lt(t) ? {
      scrollLeft: t.scrollLeft,
      scrollTop: t.scrollTop
    } : {
      scrollLeft: t.scrollX,
      scrollTop: t.scrollY
    };
  }
  function Ot(t) {
    if (Zt(t) === "html")
      return t;
    const e = (
      // Step into the shadow DOM of the parent of a slotted node.
      t.assignedSlot || // DOM Element detected.
      t.parentNode || // ShadowRoot detected.
      $n(t) && t.host || // Fallback.
      yt(t)
    );
    return $n(e) ? e.host : e;
  }
  function _r(t) {
    const e = Ot(t);
    return Kt(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : St(e) && ce(e) ? e : _r(e);
  }
  function oe(t, e, n) {
    var r;
    e === void 0 && (e = []), n === void 0 && (n = !0);
    const s = _r(t), o = s === ((r = t.ownerDocument) == null ? void 0 : r.body), a = st(s);
    if (o) {
      const l = en(a);
      return e.concat(a, a.visualViewport || [], ce(s) ? s : [], l && n ? oe(l) : []);
    }
    return e.concat(s, oe(s, [], n));
  }
  function en(t) {
    return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
  }
  function Nr(t) {
    const e = ct(t);
    let n = parseFloat(e.width) || 0, r = parseFloat(e.height) || 0;
    const s = St(t), o = s ? t.offsetWidth : n, a = s ? t.offsetHeight : r, l = we(n) !== o || we(r) !== a;
    return l && (n = o, r = a), {
      width: n,
      height: r,
      $: l
    };
  }
  function kn(t) {
    return lt(t) ? t : t.contextElement;
  }
  function Gt(t) {
    const e = kn(t);
    if (!St(e))
      return kt(1);
    const n = e.getBoundingClientRect(), {
      width: r,
      height: s,
      $: o
    } = Nr(e);
    let a = (o ? we(n.width) : n.width) / r, l = (o ? we(n.height) : n.height) / s;
    return (!a || !Number.isFinite(a)) && (a = 1), (!l || !Number.isFinite(l)) && (l = 1), {
      x: a,
      y: l
    };
  }
  const $o = /* @__PURE__ */ kt(0);
  function Dr(t) {
    const e = st(t);
    return !mn() || !e.visualViewport ? $o : {
      x: e.visualViewport.offsetLeft,
      y: e.visualViewport.offsetTop
    };
  }
  function Oo(t, e, n) {
    return e === void 0 && (e = !1), !n || e && n !== st(t) ? !1 : e;
  }
  function Nt(t, e, n, r) {
    e === void 0 && (e = !1), n === void 0 && (n = !1);
    const s = t.getBoundingClientRect(), o = kn(t);
    let a = kt(1);
    e && (r ? lt(r) && (a = Gt(r)) : a = Gt(t));
    const l = Oo(o, n, r) ? Dr(o) : kt(0);
    let u = (s.left + l.x) / a.x, i = (s.top + l.y) / a.y, c = s.width / a.x, h = s.height / a.y;
    if (o) {
      const f = st(o), p = r && lt(r) ? st(r) : r;
      let g = f, m = en(g);
      for (; m && r && p !== g; ) {
        const S = Gt(m), b = m.getBoundingClientRect(), C = ct(m), v = b.left + (m.clientLeft + parseFloat(C.paddingLeft)) * S.x, M = b.top + (m.clientTop + parseFloat(C.paddingTop)) * S.y;
        u *= S.x, i *= S.y, c *= S.x, h *= S.y, u += v, i += M, g = st(m), m = en(g);
      }
    }
    return Ae({
      width: c,
      height: h,
      x: u,
      y: i
    });
  }
  function Sn(t, e) {
    const n = Ie(t).scrollLeft;
    return e ? e.left + n : Nt(yt(t)).left + n;
  }
  function Fr(t, e, n) {
    n === void 0 && (n = !1);
    const r = t.getBoundingClientRect(), s = r.left + e.scrollLeft - (n ? 0 : (
      // RTL <body> scrollbar.
      Sn(t, r)
    )), o = r.top + e.scrollTop;
    return {
      x: s,
      y: o
    };
  }
  function Lo(t) {
    let {
      elements: e,
      rect: n,
      offsetParent: r,
      strategy: s
    } = t;
    const o = s === "fixed", a = yt(r), l = e ? Re(e.floating) : !1;
    if (r === a || l && o)
      return n;
    let u = {
      scrollLeft: 0,
      scrollTop: 0
    }, i = kt(1);
    const c = kt(0), h = St(r);
    if ((h || !h && !o) && ((Zt(r) !== "body" || ce(a)) && (u = Ie(r)), St(r))) {
      const p = Nt(r);
      i = Gt(r), c.x = p.x + r.clientLeft, c.y = p.y + r.clientTop;
    }
    const f = a && !h && !o ? Fr(a, u, !0) : kt(0);
    return {
      width: n.width * i.x,
      height: n.height * i.y,
      x: n.x * i.x - u.scrollLeft * i.x + c.x + f.x,
      y: n.y * i.y - u.scrollTop * i.y + c.y + f.y
    };
  }
  function Po(t) {
    return Array.from(t.getClientRects());
  }
  function Ro(t) {
    const e = yt(t), n = Ie(t), r = t.ownerDocument.body, s = Vt(e.scrollWidth, e.clientWidth, r.scrollWidth, r.clientWidth), o = Vt(e.scrollHeight, e.clientHeight, r.scrollHeight, r.clientHeight);
    let a = -n.scrollLeft + Sn(t);
    const l = -n.scrollTop;
    return ct(r).direction === "rtl" && (a += Vt(e.clientWidth, r.clientWidth) - s), {
      width: s,
      height: o,
      x: a,
      y: l
    };
  }
  function Io(t, e) {
    const n = st(t), r = yt(t), s = n.visualViewport;
    let o = r.clientWidth, a = r.clientHeight, l = 0, u = 0;
    if (s) {
      o = s.width, a = s.height;
      const i = mn();
      (!i || i && e === "fixed") && (l = s.offsetLeft, u = s.offsetTop);
    }
    return {
      width: o,
      height: a,
      x: l,
      y: u
    };
  }
  function _o(t, e) {
    const n = Nt(t, !0, e === "fixed"), r = n.top + t.clientTop, s = n.left + t.clientLeft, o = St(t) ? Gt(t) : kt(1), a = t.clientWidth * o.x, l = t.clientHeight * o.y, u = s * o.x, i = r * o.y;
    return {
      width: a,
      height: l,
      x: u,
      y: i
    };
  }
  function On(t, e, n) {
    let r;
    if (e === "viewport")
      r = Io(t, n);
    else if (e === "document")
      r = Ro(yt(t));
    else if (lt(e))
      r = _o(e, n);
    else {
      const s = Dr(t);
      r = {
        x: e.x - s.x,
        y: e.y - s.y,
        width: e.width,
        height: e.height
      };
    }
    return Ae(r);
  }
  function Mr(t, e) {
    const n = Ot(t);
    return n === e || !lt(n) || Kt(n) ? !1 : ct(n).position === "fixed" || Mr(n, e);
  }
  function No(t, e) {
    const n = e.get(t);
    if (n)
      return n;
    let r = oe(t, [], !1).filter((l) => lt(l) && Zt(l) !== "body"), s = null;
    const o = ct(t).position === "fixed";
    let a = o ? Ot(t) : t;
    for (; lt(a) && !Kt(a); ) {
      const l = ct(a), u = gn(a);
      !u && l.position === "fixed" && (s = null), (o ? !u && !s : !u && l.position === "static" && !!s && ["absolute", "fixed"].includes(s.position) || ce(a) && !u && Mr(t, a)) ? r = r.filter((c) => c !== a) : s = l, a = Ot(a);
    }
    return e.set(t, r), r;
  }
  function Do(t) {
    let {
      element: e,
      boundary: n,
      rootBoundary: r,
      strategy: s
    } = t;
    const a = [...n === "clippingAncestors" ? Re(e) ? [] : No(e, this._c) : [].concat(n), r], l = a[0], u = a.reduce((i, c) => {
      const h = On(e, c, s);
      return i.top = Vt(h.top, i.top), i.right = tn(h.right, i.right), i.bottom = tn(h.bottom, i.bottom), i.left = Vt(h.left, i.left), i;
    }, On(e, l, s));
    return {
      width: u.right - u.left,
      height: u.bottom - u.top,
      x: u.left,
      y: u.top
    };
  }
  function Fo(t) {
    const {
      width: e,
      height: n
    } = Nr(t);
    return {
      width: e,
      height: n
    };
  }
  function Mo(t, e, n) {
    const r = St(e), s = yt(e), o = n === "fixed", a = Nt(t, !0, o, e);
    let l = {
      scrollLeft: 0,
      scrollTop: 0
    };
    const u = kt(0);
    function i() {
      u.x = Sn(s);
    }
    if (r || !r && !o)
      if ((Zt(e) !== "body" || ce(s)) && (l = Ie(e)), r) {
        const p = Nt(e, !0, o, e);
        u.x = p.x + e.clientLeft, u.y = p.y + e.clientTop;
      } else s && i();
    o && !r && s && i();
    const c = s && !r && !o ? Fr(s, l) : kt(0), h = a.left + l.scrollLeft - u.x - c.x, f = a.top + l.scrollTop - u.y - c.y;
    return {
      x: h,
      y: f,
      width: a.width,
      height: a.height
    };
  }
  function Ne(t) {
    return ct(t).position === "static";
  }
  function Ln(t, e) {
    if (!St(t) || ct(t).position === "fixed")
      return null;
    if (e)
      return e(t);
    let n = t.offsetParent;
    return yt(t) === n && (n = n.ownerDocument.body), n;
  }
  function jr(t, e) {
    const n = st(t);
    if (Re(t))
      return n;
    if (!St(t)) {
      let s = Ot(t);
      for (; s && !Kt(s); ) {
        if (lt(s) && !Ne(s))
          return s;
        s = Ot(s);
      }
      return n;
    }
    let r = Ln(t, e);
    for (; r && vo(r) && Ne(r); )
      r = Ln(r, e);
    return r && Kt(r) && Ne(r) && !gn(r) ? n : r || Eo(t) || n;
  }
  const jo = function(t) {
    return R(this, null, function* () {
      const e = this.getOffsetParent || jr, n = this.getDimensions, r = yield n(t.floating);
      return {
        reference: Mo(t.reference, yield e(t.floating), t.strategy),
        floating: {
          x: 0,
          y: 0,
          width: r.width,
          height: r.height
        }
      };
    });
  };
  function Bo(t) {
    return ct(t).direction === "rtl";
  }
  const H = {
    convertOffsetParentRelativeRectToViewportRelativeRect: Lo,
    getDocumentElement: yt,
    getClippingRect: Do,
    getOffsetParent: jr,
    getElementRects: jo,
    getClientRects: Po,
    getDimensions: Fo,
    getScale: Gt,
    isElement: lt,
    isRTL: Bo
  };
  function Br(t, e) {
    return t.x === e.x && t.y === e.y && t.width === e.width && t.height === e.height;
  }
  function Uo(t, e) {
    let n = null, r;
    const s = yt(t);
    function o() {
      var l;
      clearTimeout(r), (l = n) == null || l.disconnect(), n = null;
    }
    function a(l, u) {
      l === void 0 && (l = !1), u === void 0 && (u = 1), o();
      const i = t.getBoundingClientRect(), {
        left: c,
        top: h,
        width: f,
        height: p
      } = i;
      if (l || e(), !f || !p)
        return;
      const g = fe(h), m = fe(s.clientWidth - (c + f)), S = fe(s.clientHeight - (h + p)), b = fe(c), v = {
        rootMargin: -g + "px " + -m + "px " + -S + "px " + -b + "px",
        threshold: Vt(0, tn(1, u)) || 1
      };
      let M = !0;
      function k(P) {
        const w = P[0].intersectionRatio;
        if (w !== u) {
          if (!M)
            return a();
          w ? a(!1, w) : r = setTimeout(() => {
            a(!1, 1e-7);
          }, 1e3);
        }
        w === 1 && !Br(i, t.getBoundingClientRect()) && a(), M = !1;
      }
      try {
        n = new IntersectionObserver(k, q(W({}, v), {
          // Handle <iframe>s
          root: s.ownerDocument
        }));
      } catch (P) {
        n = new IntersectionObserver(k, v);
      }
      n.observe(t);
    }
    return a(!0), o;
  }
  function nn(t, e, n, r) {
    r === void 0 && (r = {});
    const {
      ancestorScroll: s = !0,
      ancestorResize: o = !0,
      elementResize: a = typeof ResizeObserver == "function",
      layoutShift: l = typeof IntersectionObserver == "function",
      animationFrame: u = !1
    } = r, i = kn(t), c = s || o ? [...i ? oe(i) : [], ...oe(e)] : [];
    c.forEach((b) => {
      s && b.addEventListener("scroll", n, {
        passive: !0
      }), o && b.addEventListener("resize", n);
    });
    const h = i && l ? Uo(i, n) : null;
    let f = -1, p = null;
    a && (p = new ResizeObserver((b) => {
      let [C] = b;
      C && C.target === i && p && (p.unobserve(e), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
        var v;
        (v = p) == null || v.observe(e);
      })), n();
    }), i && !u && p.observe(i), p.observe(e));
    let g, m = u ? Nt(t) : null;
    u && S();
    function S() {
      const b = Nt(t);
      m && !Br(m, b) && n(), m = b, g = requestAnimationFrame(S);
    }
    return n(), () => {
      var b;
      c.forEach((C) => {
        s && C.removeEventListener("scroll", n), o && C.removeEventListener("resize", n);
      }), h == null || h(), (b = p) == null || b.disconnect(), p = null, u && cancelAnimationFrame(g);
    };
  }
  const Wo = To, { hasOwnProperty: yn } = Object.prototype, ee = function() {
  };
  function Pn(t) {
    return typeof t == "function" ? t : ee;
  }
  function Rn(t, e) {
    return function(n, r, s) {
      n.type === e && t.call(this, n, r, s);
    };
  }
  function zo(t, e) {
    const n = e.structure, r = [];
    for (const s in n) {
      if (yn.call(n, s) === !1)
        continue;
      let o = n[s];
      const a = {
        name: s,
        type: !1,
        nullable: !1
      };
      Array.isArray(o) || (o = [o]);
      for (const l of o)
        l === null ? a.nullable = !0 : typeof l == "string" ? a.type = "node" : Array.isArray(l) && (a.type = "list");
      a.type && r.push(a);
    }
    return r.length ? {
      context: e.walkContext,
      fields: r
    } : null;
  }
  function Ho(t) {
    const e = {};
    for (const n in t.node)
      if (yn.call(t.node, n)) {
        const r = t.node[n];
        if (!r.structure)
          throw new Error("Missed `structure` field in `" + n + "` node type definition");
        e[n] = zo(n, r);
      }
    return e;
  }
  function In(t, e) {
    const n = t.fields.slice(), r = t.context, s = typeof r == "string";
    return e && n.reverse(), function(o, a, l, u) {
      let i;
      s && (i = a[r], a[r] = o);
      for (const c of n) {
        const h = o[c.name];
        if (!c.nullable || h) {
          if (c.type === "list") {
            if (e ? h.reduceRight(u, !1) : h.reduce(u, !1))
              return !0;
          } else if (l(h))
            return !0;
        }
      }
      s && (a[r] = i);
    };
  }
  function _n({
    StyleSheet: t,
    Atrule: e,
    Rule: n,
    Block: r,
    DeclarationList: s
  }) {
    return {
      Atrule: {
        StyleSheet: t,
        Atrule: e,
        Rule: n,
        Block: r
      },
      Rule: {
        StyleSheet: t,
        Atrule: e,
        Rule: n,
        Block: r
      },
      Declaration: {
        StyleSheet: t,
        Atrule: e,
        Rule: n,
        Block: r,
        DeclarationList: s
      }
    };
  }
  function Vo(t) {
    const e = Ho(t), n = {}, r = {}, s = Symbol("break-walk"), o = Symbol("skip-node");
    for (const i in e)
      yn.call(e, i) && e[i] !== null && (n[i] = In(e[i], !1), r[i] = In(e[i], !0));
    const a = _n(n), l = _n(r), u = function(i, c) {
      function h(b, C, v) {
        const M = f.call(S, b, C, v);
        return M === s ? !0 : M === o ? !1 : !!(g.hasOwnProperty(b.type) && g[b.type](b, S, h, m) || p.call(S, b, C, v) === s);
      }
      let f = ee, p = ee, g = n, m = (b, C, v, M) => b || h(C, v, M);
      const S = {
        break: s,
        skip: o,
        root: i,
        stylesheet: null,
        atrule: null,
        atrulePrelude: null,
        rule: null,
        selector: null,
        block: null,
        declaration: null,
        function: null
      };
      if (typeof c == "function")
        f = c;
      else if (c && (f = Pn(c.enter), p = Pn(c.leave), c.reverse && (g = r), c.visit)) {
        if (a.hasOwnProperty(c.visit))
          g = c.reverse ? l[c.visit] : a[c.visit];
        else if (!e.hasOwnProperty(c.visit))
          throw new Error("Bad value `" + c.visit + "` for `visit` option (should be: " + Object.keys(e).sort().join(", ") + ")");
        f = Rn(f, c.visit), p = Rn(p, c.visit);
      }
      if (f === ee && p === ee)
        throw new Error("Neither `enter` nor `leave` walker handler is set or both aren't a function");
      h(i);
    };
    return u.break = s, u.skip = o, u.find = function(i, c) {
      let h = null;
      return u(i, function(f, p, g) {
        if (c.call(this, f, p, g))
          return h = f, s;
      }), h;
    }, u.findLast = function(i, c) {
      let h = null;
      return u(i, {
        reverse: !0,
        enter(f, p, g) {
          if (c.call(this, f, p, g))
            return h = f, s;
        }
      }), h;
    }, u.findAll = function(i, c) {
      const h = [];
      return u(i, function(f, p, g) {
        c.call(this, f, p, g) && h.push(f);
      }), h;
    }, u;
  }
  const Tt = 0, d = 1, A = 2, z = 3, N = 4, wt = 5, Go = 6, Q = 7, ot = 8, L = 9, x = 10, F = 11, $ = 12, U = 13, _e = 14, et = 15, X = 16, tt = 17, ht = 18, te = 19, ae = 20, I = 21, y = 22, ut = 23, Qt = 24, Y = 25, qo = 0;
  function rt(t) {
    return t >= 48 && t <= 57;
  }
  function Yt(t) {
    return rt(t) || // 0 .. 9
    t >= 65 && t <= 70 || // A .. F
    t >= 97 && t <= 102;
  }
  function bn(t) {
    return t >= 65 && t <= 90;
  }
  function Ko(t) {
    return t >= 97 && t <= 122;
  }
  function Qo(t) {
    return bn(t) || Ko(t);
  }
  function Yo(t) {
    return t >= 128;
  }
  function Te(t) {
    return Qo(t) || Yo(t) || t === 95;
  }
  function Ur(t) {
    return Te(t) || rt(t) || t === 45;
  }
  function Xo(t) {
    return t >= 0 && t <= 8 || t === 11 || t >= 14 && t <= 31 || t === 127;
  }
  function ve(t) {
    return t === 10 || t === 13 || t === 12;
  }
  function Dt(t) {
    return ve(t) || t === 32 || t === 9;
  }
  function mt(t, e) {
    return !(t !== 92 || ve(e) || e === qo);
  }
  function De(t, e, n) {
    return t === 45 ? Te(e) || e === 45 || mt(e, n) : Te(t) ? !0 : t === 92 ? mt(t, e) : !1;
  }
  function Fe(t, e, n) {
    return t === 43 || t === 45 ? rt(e) ? 2 : e === 46 && rt(n) ? 3 : 0 : t === 46 ? rt(e) ? 2 : 0 : rt(t) ? 1 : 0;
  }
  function Wr(t) {
    return t === 65279 || t === 65534 ? 1 : 0;
  }
  const rn = new Array(128), Jo = 128, Se = 130, zr = 131, xn = 132, Hr = 133;
  for (let t = 0; t < rn.length; t++)
    rn[t] = Dt(t) && Se || rt(t) && zr || Te(t) && xn || Xo(t) && Hr || t || Jo;
  function Me(t) {
    return t < 128 ? rn[t] : xn;
  }
  function qt(t, e) {
    return e < t.length ? t.charCodeAt(e) : 0;
  }
  function sn(t, e, n) {
    return n === 13 && qt(t, e + 1) === 10 ? 2 : 1;
  }
  function Vr(t, e, n) {
    let r = t.charCodeAt(e);
    return bn(r) && (r = r | 32), r === n;
  }
  function Ee(t, e, n, r) {
    if (n - e !== r.length || e < 0 || n > t.length)
      return !1;
    for (let s = e; s < n; s++) {
      const o = r.charCodeAt(s - e);
      let a = t.charCodeAt(s);
      if (bn(a) && (a = a | 32), a !== o)
        return !1;
    }
    return !0;
  }
  function Zo(t, e) {
    for (; e >= 0 && Dt(t.charCodeAt(e)); e--)
      ;
    return e + 1;
  }
  function pe(t, e) {
    for (; e < t.length && Dt(t.charCodeAt(e)); e++)
      ;
    return e;
  }
  function je(t, e) {
    for (; e < t.length && rt(t.charCodeAt(e)); e++)
      ;
    return e;
  }
  function Xt(t, e) {
    if (e += 2, Yt(qt(t, e - 1))) {
      for (const r = Math.min(t.length, e + 5); e < r && Yt(qt(t, e)); e++)
        ;
      const n = qt(t, e);
      Dt(n) && (e += sn(t, e, n));
    }
    return e;
  }
  function de(t, e) {
    for (; e < t.length; e++) {
      const n = t.charCodeAt(e);
      if (!Ur(n)) {
        if (mt(n, qt(t, e + 1))) {
          e = Xt(t, e) - 1;
          continue;
        }
        break;
      }
    }
    return e;
  }
  function Gr(t, e) {
    let n = t.charCodeAt(e);
    if ((n === 43 || n === 45) && (n = t.charCodeAt(e += 1)), rt(n) && (e = je(t, e + 1), n = t.charCodeAt(e)), n === 46 && rt(t.charCodeAt(e + 1)) && (e += 2, e = je(t, e)), Vr(
      t,
      e,
      101
      /* e */
    )) {
      let r = 0;
      n = t.charCodeAt(e + 1), (n === 45 || n === 43) && (r = 1, n = t.charCodeAt(e + 2)), rt(n) && (e = je(t, e + 1 + r + 1));
    }
    return e;
  }
  function Be(t, e) {
    for (; e < t.length; e++) {
      const n = t.charCodeAt(e);
      if (n === 41) {
        e++;
        break;
      }
      mt(n, qt(t, e + 1)) && (e = Xt(t, e));
    }
    return e;
  }
  function qr(t) {
    if (t.length === 1 && !Yt(t.charCodeAt(0)))
      return t[0];
    let e = parseInt(t, 16);
    return (e === 0 || // If this number is zero,
    e >= 55296 && e <= 57343 || // or is for a surrogate,
    e > 1114111) && (e = 65533), String.fromCodePoint(e);
  }
  const Kr = [
    "EOF-token",
    "ident-token",
    "function-token",
    "at-keyword-token",
    "hash-token",
    "string-token",
    "bad-string-token",
    "url-token",
    "bad-url-token",
    "delim-token",
    "number-token",
    "percentage-token",
    "dimension-token",
    "whitespace-token",
    "CDO-token",
    "CDC-token",
    "colon-token",
    "semicolon-token",
    "comma-token",
    "[-token",
    "]-token",
    "(-token",
    ")-token",
    "{-token",
    "}-token",
    "comment-token"
  ], ta = 16 * 1024;
  function $e(t = null, e) {
    return t === null || t.length < e ? new Uint32Array(Math.max(e + 1024, ta)) : t;
  }
  const Nn = 10, ea = 12, Dn = 13;
  function Fn(t) {
    const e = t.source, n = e.length, r = e.length > 0 ? Wr(e.charCodeAt(0)) : 0, s = $e(t.lines, n), o = $e(t.columns, n);
    let a = t.startLine, l = t.startColumn;
    for (let u = r; u < n; u++) {
      const i = e.charCodeAt(u);
      s[u] = a, o[u] = l++, (i === Nn || i === Dn || i === ea) && (i === Dn && u + 1 < n && e.charCodeAt(u + 1) === Nn && (u++, s[u] = a, o[u] = l), a++, l = 1);
    }
    s[n] = a, o[n] = l, t.lines = s, t.columns = o, t.computed = !0;
  }
  class na {
    constructor(e, n, r, s) {
      this.setSource(e, n, r, s), this.lines = null, this.columns = null;
    }
    setSource(e = "", n = 0, r = 1, s = 1) {
      this.source = e, this.startOffset = n, this.startLine = r, this.startColumn = s, this.computed = !1;
    }
    getLocation(e, n) {
      return this.computed || Fn(this), {
        source: n,
        offset: this.startOffset + e,
        line: this.lines[e],
        column: this.columns[e]
      };
    }
    getLocationRange(e, n, r) {
      return this.computed || Fn(this), {
        source: r,
        start: {
          offset: this.startOffset + e,
          line: this.lines[e],
          column: this.columns[e]
        },
        end: {
          offset: this.startOffset + n,
          line: this.lines[n],
          column: this.columns[n]
        }
      };
    }
  }
  const pt = 16777215, dt = 24, Ft = new Uint8Array(32);
  Ft[A] = y;
  Ft[I] = y;
  Ft[te] = ae;
  Ft[ut] = Qt;
  function Mn(t) {
    return Ft[t] !== 0;
  }
  class ra {
    constructor(e, n) {
      this.setSource(e, n);
    }
    reset() {
      this.eof = !1, this.tokenIndex = -1, this.tokenType = 0, this.tokenStart = this.firstCharOffset, this.tokenEnd = this.firstCharOffset;
    }
    setSource(e = "", n = () => {
    }) {
      e = String(e || "");
      const r = e.length, s = $e(this.offsetAndType, e.length + 1), o = $e(this.balance, e.length + 1);
      let a = 0, l = -1, u = 0, i = e.length;
      this.offsetAndType = null, this.balance = null, o.fill(0), n(e, (c, h, f) => {
        const p = a++;
        if (s[p] = c << dt | f, l === -1 && (l = h), o[p] = i, c === u) {
          const g = o[i];
          o[i] = p, i = g, u = Ft[s[g] >> dt];
        } else Mn(c) && (i = p, u = Ft[c]);
      }), s[a] = Tt << dt | r, o[a] = a;
      for (let c = 0; c < a; c++) {
        const h = o[c];
        if (h <= c) {
          const f = o[h];
          f !== c && (o[c] = f);
        } else h > a && (o[c] = a);
      }
      this.source = e, this.firstCharOffset = l === -1 ? 0 : l, this.tokenCount = a, this.offsetAndType = s, this.balance = o, this.reset(), this.next();
    }
    lookupType(e) {
      return e += this.tokenIndex, e < this.tokenCount ? this.offsetAndType[e] >> dt : Tt;
    }
    lookupTypeNonSC(e) {
      for (let n = this.tokenIndex; n < this.tokenCount; n++) {
        const r = this.offsetAndType[n] >> dt;
        if (r !== U && r !== Y && e-- === 0)
          return r;
      }
      return Tt;
    }
    lookupOffset(e) {
      return e += this.tokenIndex, e < this.tokenCount ? this.offsetAndType[e - 1] & pt : this.source.length;
    }
    lookupOffsetNonSC(e) {
      for (let n = this.tokenIndex; n < this.tokenCount; n++) {
        const r = this.offsetAndType[n] >> dt;
        if (r !== U && r !== Y && e-- === 0)
          return n - this.tokenIndex;
      }
      return Tt;
    }
    lookupValue(e, n) {
      return e += this.tokenIndex, e < this.tokenCount ? Ee(
        this.source,
        this.offsetAndType[e - 1] & pt,
        this.offsetAndType[e] & pt,
        n
      ) : !1;
    }
    getTokenStart(e) {
      return e === this.tokenIndex ? this.tokenStart : e > 0 ? e < this.tokenCount ? this.offsetAndType[e - 1] & pt : this.offsetAndType[this.tokenCount] & pt : this.firstCharOffset;
    }
    substrToCursor(e) {
      return this.source.substring(e, this.tokenStart);
    }
    isBalanceEdge(e) {
      return this.balance[this.tokenIndex] < e;
    }
    isDelim(e, n) {
      return n ? this.lookupType(n) === L && this.source.charCodeAt(this.lookupOffset(n)) === e : this.tokenType === L && this.source.charCodeAt(this.tokenStart) === e;
    }
    skip(e) {
      let n = this.tokenIndex + e;
      n < this.tokenCount ? (this.tokenIndex = n, this.tokenStart = this.offsetAndType[n - 1] & pt, n = this.offsetAndType[n], this.tokenType = n >> dt, this.tokenEnd = n & pt) : (this.tokenIndex = this.tokenCount, this.next());
    }
    next() {
      let e = this.tokenIndex + 1;
      e < this.tokenCount ? (this.tokenIndex = e, this.tokenStart = this.tokenEnd, e = this.offsetAndType[e], this.tokenType = e >> dt, this.tokenEnd = e & pt) : (this.eof = !0, this.tokenIndex = this.tokenCount, this.tokenType = Tt, this.tokenStart = this.tokenEnd = this.source.length);
    }
    skipSC() {
      for (; this.tokenType === U || this.tokenType === Y; )
        this.next();
    }
    skipUntilBalanced(e, n) {
      let r = e, s = 0, o = 0;
      t:
        for (; r < this.tokenCount; r++) {
          if (s = this.balance[r], s < e)
            break t;
          switch (o = r > 0 ? this.offsetAndType[r - 1] & pt : this.firstCharOffset, n(this.source.charCodeAt(o))) {
            case 1:
              break t;
            case 2:
              r++;
              break t;
            default:
              Mn(this.offsetAndType[r] >> dt) && (r = s);
          }
        }
      this.skip(r - this.tokenIndex);
    }
    forEachToken(e) {
      for (let n = 0, r = this.firstCharOffset; n < this.tokenCount; n++) {
        const s = r, o = this.offsetAndType[n], a = o & pt, l = o >> dt;
        r = a, e(l, s, a, n);
      }
    }
    dump() {
      const e = new Array(this.tokenCount);
      return this.forEachToken((n, r, s, o) => {
        e[o] = {
          idx: o,
          type: Kr[n],
          chunk: this.source.substring(r, s),
          balance: this.balance[o]
        };
      }), e;
    }
  }
  function Qr(t, e) {
    function n(h) {
      return h < l ? t.charCodeAt(h) : 0;
    }
    function r() {
      if (i = Gr(t, i), De(n(i), n(i + 1), n(i + 2))) {
        c = $, i = de(t, i);
        return;
      }
      if (n(i) === 37) {
        c = F, i++;
        return;
      }
      c = x;
    }
    function s() {
      const h = i;
      if (i = de(t, i), Ee(t, h, i, "url") && n(i) === 40) {
        if (i = pe(t, i + 1), n(i) === 34 || n(i) === 39) {
          c = A, i = h + 4;
          return;
        }
        a();
        return;
      }
      if (n(i) === 40) {
        c = A, i++;
        return;
      }
      c = d;
    }
    function o(h) {
      for (h || (h = n(i++)), c = wt; i < t.length; i++) {
        const f = t.charCodeAt(i);
        switch (Me(f)) {
          // ending code point
          case h:
            i++;
            return;
          // EOF
          // case EofCategory:
          // This is a parse error. Return the <string-token>.
          // return;
          // newline
          case Se:
            if (ve(f)) {
              i += sn(t, i, f), c = Go;
              return;
            }
            break;
          // U+005C REVERSE SOLIDUS (\)
          case 92:
            if (i === t.length - 1)
              break;
            const p = n(i + 1);
            ve(p) ? i += sn(t, i + 1, p) : mt(f, p) && (i = Xt(t, i) - 1);
            break;
        }
      }
    }
    function a() {
      for (c = Q, i = pe(t, i); i < t.length; i++) {
        const h = t.charCodeAt(i);
        switch (Me(h)) {
          // U+0029 RIGHT PARENTHESIS ())
          case 41:
            i++;
            return;
          // EOF
          // case EofCategory:
          // This is a parse error. Return the <url-token>.
          // return;
          // whitespace
          case Se:
            if (i = pe(t, i), n(i) === 41 || i >= t.length) {
              i < t.length && i++;
              return;
            }
            i = Be(t, i), c = ot;
            return;
          // U+0022 QUOTATION MARK (")
          // U+0027 APOSTROPHE (')
          // U+0028 LEFT PARENTHESIS (()
          // non-printable code point
          case 34:
          case 39:
          case 40:
          case Hr:
            i = Be(t, i), c = ot;
            return;
          // U+005C REVERSE SOLIDUS (\)
          case 92:
            if (mt(h, n(i + 1))) {
              i = Xt(t, i) - 1;
              break;
            }
            i = Be(t, i), c = ot;
            return;
        }
      }
    }
    t = String(t || "");
    const l = t.length;
    let u = Wr(n(0)), i = u, c;
    for (; i < l; ) {
      const h = t.charCodeAt(i);
      switch (Me(h)) {
        // whitespace
        case Se:
          c = U, i = pe(t, i + 1);
          break;
        // U+0022 QUOTATION MARK (")
        case 34:
          o();
          break;
        // U+0023 NUMBER SIGN (#)
        case 35:
          Ur(n(i + 1)) || mt(n(i + 1), n(i + 2)) ? (c = N, i = de(t, i + 1)) : (c = L, i++);
          break;
        // U+0027 APOSTROPHE (')
        case 39:
          o();
          break;
        // U+0028 LEFT PARENTHESIS (()
        case 40:
          c = I, i++;
          break;
        // U+0029 RIGHT PARENTHESIS ())
        case 41:
          c = y, i++;
          break;
        // U+002B PLUS SIGN (+)
        case 43:
          Fe(h, n(i + 1), n(i + 2)) ? r() : (c = L, i++);
          break;
        // U+002C COMMA (,)
        case 44:
          c = ht, i++;
          break;
        // U+002D HYPHEN-MINUS (-)
        case 45:
          Fe(h, n(i + 1), n(i + 2)) ? r() : n(i + 1) === 45 && n(i + 2) === 62 ? (c = et, i = i + 3) : De(h, n(i + 1), n(i + 2)) ? s() : (c = L, i++);
          break;
        // U+002E FULL STOP (.)
        case 46:
          Fe(h, n(i + 1), n(i + 2)) ? r() : (c = L, i++);
          break;
        // U+002F SOLIDUS (/)
        case 47:
          n(i + 1) === 42 ? (c = Y, i = t.indexOf("*/", i + 2), i = i === -1 ? t.length : i + 2) : (c = L, i++);
          break;
        // U+003A COLON (:)
        case 58:
          c = X, i++;
          break;
        // U+003B SEMICOLON (;)
        case 59:
          c = tt, i++;
          break;
        // U+003C LESS-THAN SIGN (<)
        case 60:
          n(i + 1) === 33 && n(i + 2) === 45 && n(i + 3) === 45 ? (c = _e, i = i + 4) : (c = L, i++);
          break;
        // U+0040 COMMERCIAL AT (@)
        case 64:
          De(n(i + 1), n(i + 2), n(i + 3)) ? (c = z, i = de(t, i + 1)) : (c = L, i++);
          break;
        // U+005B LEFT SQUARE BRACKET ([)
        case 91:
          c = te, i++;
          break;
        // U+005C REVERSE SOLIDUS (\)
        case 92:
          mt(h, n(i + 1)) ? s() : (c = L, i++);
          break;
        // U+005D RIGHT SQUARE BRACKET (])
        case 93:
          c = ae, i++;
          break;
        // U+007B LEFT CURLY BRACKET ({)
        case 123:
          c = ut, i++;
          break;
        // U+007D RIGHT CURLY BRACKET (})
        case 125:
          c = Qt, i++;
          break;
        // digit
        case zr:
          r();
          break;
        // name-start code point
        case xn:
          s();
          break;
        // EOF
        // case EofCategory:
        // Return an <EOF-token>.
        // break;
        // anything else
        default:
          c = L, i++;
      }
      e(c, u, u = i);
    }
  }
  const gt = 43, nt = 45, ye = 110, Rt = !0, sa = !1;
  function be(t, e) {
    let n = this.tokenStart + t;
    const r = this.charCodeAt(n);
    for ((r === gt || r === nt) && (e && this.error("Number sign is not allowed"), n++); n < this.tokenEnd; n++)
      rt(this.charCodeAt(n)) || this.error("Integer is expected", n);
  }
  function zt(t) {
    return be.call(this, 0, t);
  }
  function At(t, e) {
    if (!this.cmpChar(this.tokenStart + t, e)) {
      let n = "";
      switch (e) {
        case ye:
          n = "N is expected";
          break;
        case nt:
          n = "HyphenMinus is expected";
          break;
      }
      this.error(n, this.tokenStart + t);
    }
  }
  function Ue() {
    let t = 0, e = 0, n = this.tokenType;
    for (; n === U || n === Y; )
      n = this.lookupType(++t);
    if (n !== x)
      if (this.isDelim(gt, t) || this.isDelim(nt, t)) {
        e = this.isDelim(gt, t) ? gt : nt;
        do
          n = this.lookupType(++t);
        while (n === U || n === Y);
        n !== x && (this.skip(t), zt.call(this, Rt));
      } else
        return null;
    return t > 0 && this.skip(t), e === 0 && (n = this.charCodeAt(this.tokenStart), n !== gt && n !== nt && this.error("Number sign is expected")), zt.call(this, e !== 0), e === nt ? "-" + this.consume(x) : this.consume(x);
  }
  const ia = "AnPlusB", oa = {
    a: [String, null],
    b: [String, null]
  };
  function Yr() {
    const t = this.tokenStart;
    let e = null, n = null;
    if (this.tokenType === x)
      zt.call(this, sa), n = this.consume(x);
    else if (this.tokenType === d && this.cmpChar(this.tokenStart, nt))
      switch (e = "-1", At.call(this, 1, ye), this.tokenEnd - this.tokenStart) {
        // -n
        // -n <signed-integer>
        // -n ['+' | '-'] <signless-integer>
        case 2:
          this.next(), n = Ue.call(this);
          break;
        // -n- <signless-integer>
        case 3:
          At.call(this, 2, nt), this.next(), this.skipSC(), zt.call(this, Rt), n = "-" + this.consume(x);
          break;
        // <dashndashdigit-ident>
        default:
          At.call(this, 2, nt), be.call(this, 3, Rt), this.next(), n = this.substrToCursor(t + 2);
      }
    else if (this.tokenType === d || this.isDelim(gt) && this.lookupType(1) === d) {
      let r = 0;
      switch (e = "1", this.isDelim(gt) && (r = 1, this.next()), At.call(this, 0, ye), this.tokenEnd - this.tokenStart) {
        // '+'? n
        // '+'? n <signed-integer>
        // '+'? n ['+' | '-'] <signless-integer>
        case 1:
          this.next(), n = Ue.call(this);
          break;
        // '+'? n- <signless-integer>
        case 2:
          At.call(this, 1, nt), this.next(), this.skipSC(), zt.call(this, Rt), n = "-" + this.consume(x);
          break;
        // '+'? <ndashdigit-ident>
        default:
          At.call(this, 1, nt), be.call(this, 2, Rt), this.next(), n = this.substrToCursor(t + r + 1);
      }
    } else if (this.tokenType === $) {
      const r = this.charCodeAt(this.tokenStart), s = r === gt || r === nt;
      let o = this.tokenStart + s;
      for (; o < this.tokenEnd && rt(this.charCodeAt(o)); o++)
        ;
      o === this.tokenStart + s && this.error("Integer is expected", this.tokenStart + s), At.call(this, o - this.tokenStart, ye), e = this.substring(t, o), o + 1 === this.tokenEnd ? (this.next(), n = Ue.call(this)) : (At.call(this, o - this.tokenStart + 1, nt), o + 2 === this.tokenEnd ? (this.next(), this.skipSC(), zt.call(this, Rt), n = "-" + this.consume(x)) : (be.call(this, o - this.tokenStart + 2, Rt), this.next(), n = this.substrToCursor(o + 1)));
    } else
      this.error();
    return e !== null && e.charCodeAt(0) === gt && (e = e.substr(1)), n !== null && n.charCodeAt(0) === gt && (n = n.substr(1)), {
      type: "AnPlusB",
      loc: this.getLocation(t, this.tokenStart),
      a: e,
      b: n
    };
  }
  function Xr(t) {
    if (t.a) {
      const e = t.a === "+1" && "n" || t.a === "1" && "n" || t.a === "-1" && "-n" || t.a + "n";
      if (t.b) {
        const n = t.b[0] === "-" || t.b[0] === "+" ? t.b : "+" + t.b;
        this.tokenize(e + n);
      } else
        this.tokenize(e);
    } else
      this.tokenize(t.b);
  }
  const aa = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: Xr,
    name: ia,
    parse: Yr,
    structure: oa
  }, Symbol.toStringTag, { value: "Module" }));
  function jn() {
    return this.Raw(this.consumeUntilLeftCurlyBracketOrSemicolon, !0);
  }
  function la() {
    for (let t = 1, e; e = this.lookupType(t); t++) {
      if (e === Qt)
        return !0;
      if (e === ut || e === z)
        return !1;
    }
    return !1;
  }
  const ca = "Atrule", ua = "atrule", ha = {
    name: String,
    prelude: ["AtrulePrelude", "Raw", null],
    block: ["Block", null]
  };
  function Jr(t = !1) {
    const e = this.tokenStart;
    let n, r, s = null, o = null;
    switch (this.eat(z), n = this.substrToCursor(e + 1), r = n.toLowerCase(), this.skipSC(), this.eof === !1 && this.tokenType !== ut && this.tokenType !== tt && (this.parseAtrulePrelude ? s = this.parseWithFallback(this.AtrulePrelude.bind(this, n, t), jn) : s = jn.call(this, this.tokenIndex), this.skipSC()), this.tokenType) {
      case tt:
        this.next();
        break;
      case ut:
        hasOwnProperty.call(this.atrule, r) && typeof this.atrule[r].block == "function" ? o = this.atrule[r].block.call(this, t) : o = this.Block(la.call(this));
        break;
    }
    return {
      type: "Atrule",
      loc: this.getLocation(e, this.tokenStart),
      name: n,
      prelude: s,
      block: o
    };
  }
  function Zr(t) {
    this.token(z, "@" + t.name), t.prelude !== null && this.node(t.prelude), t.block ? this.node(t.block) : this.token(tt, ";");
  }
  const fa = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: Zr,
    name: ca,
    parse: Jr,
    structure: ha,
    walkContext: ua
  }, Symbol.toStringTag, { value: "Module" })), pa = "AtrulePrelude", da = "atrulePrelude", ga = {
    children: [[]]
  };
  function ts(t) {
    let e = null;
    return t !== null && (t = t.toLowerCase()), this.skipSC(), hasOwnProperty.call(this.atrule, t) && typeof this.atrule[t].prelude == "function" ? e = this.atrule[t].prelude.call(this) : e = this.readSequence(this.scope.AtrulePrelude), this.skipSC(), this.eof !== !0 && this.tokenType !== ut && this.tokenType !== tt && this.error("Semicolon or block is expected"), {
      type: "AtrulePrelude",
      loc: this.getLocationFromList(e),
      children: e
    };
  }
  function es(t) {
    this.children(t);
  }
  const ma = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: es,
    name: pa,
    parse: ts,
    structure: ga,
    walkContext: da
  }, Symbol.toStringTag, { value: "Module" })), ka = 36, ns = 42, xe = 61, Sa = 94, on = 124, ya = 126;
  function ba() {
    this.eof && this.error("Unexpected end of input");
    const t = this.tokenStart;
    let e = !1;
    return this.isDelim(ns) ? (e = !0, this.next()) : this.isDelim(on) || this.eat(d), this.isDelim(on) ? this.charCodeAt(this.tokenStart + 1) !== xe ? (this.next(), this.eat(d)) : e && this.error("Identifier is expected", this.tokenEnd) : e && this.error("Vertical line is expected"), {
      type: "Identifier",
      loc: this.getLocation(t, this.tokenStart),
      name: this.substrToCursor(t)
    };
  }
  function xa() {
    const t = this.tokenStart, e = this.charCodeAt(t);
    return e !== xe && // =
    e !== ya && // ~=
    e !== Sa && // ^=
    e !== ka && // $=
    e !== ns && // *=
    e !== on && this.error("Attribute selector (=, ~=, ^=, $=, *=, |=) is expected"), this.next(), e !== xe && (this.isDelim(xe) || this.error("Equal sign is expected"), this.next()), this.substrToCursor(t);
  }
  const Ca = "AttributeSelector", wa = {
    name: "Identifier",
    matcher: [String, null],
    value: ["String", "Identifier", null],
    flags: [String, null]
  };
  function rs() {
    const t = this.tokenStart;
    let e, n = null, r = null, s = null;
    return this.eat(te), this.skipSC(), e = ba.call(this), this.skipSC(), this.tokenType !== ae && (this.tokenType !== d && (n = xa.call(this), this.skipSC(), r = this.tokenType === wt ? this.String() : this.Identifier(), this.skipSC()), this.tokenType === d && (s = this.consume(d), this.skipSC())), this.eat(ae), {
      type: "AttributeSelector",
      loc: this.getLocation(t, this.tokenStart),
      name: e,
      matcher: n,
      value: r,
      flags: s
    };
  }
  function ss(t) {
    this.token(L, "["), this.node(t.name), t.matcher !== null && (this.tokenize(t.matcher), this.node(t.value)), t.flags !== null && this.token(d, t.flags), this.token(L, "]");
  }
  const Aa = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: ss,
    name: Ca,
    parse: rs,
    structure: wa
  }, Symbol.toStringTag, { value: "Module" })), Ta = 38;
  function is() {
    return this.Raw(null, !0);
  }
  function Bn() {
    return this.parseWithFallback(this.Rule, is);
  }
  function Un() {
    return this.Raw(this.consumeUntilSemicolonIncluded, !0);
  }
  function va() {
    if (this.tokenType === tt)
      return Un.call(this, this.tokenIndex);
    const t = this.parseWithFallback(this.Declaration, Un);
    return this.tokenType === tt && this.next(), t;
  }
  const Ea = "Block", $a = "block", Oa = {
    children: [[
      "Atrule",
      "Rule",
      "Declaration"
    ]]
  };
  function os(t) {
    const e = t ? va : Bn, n = this.tokenStart;
    let r = this.createList();
    this.eat(ut);
    t:
      for (; !this.eof; )
        switch (this.tokenType) {
          case Qt:
            break t;
          case U:
          case Y:
            this.next();
            break;
          case z:
            r.push(this.parseWithFallback(this.Atrule.bind(this, t), is));
            break;
          default:
            t && this.isDelim(Ta) ? r.push(Bn.call(this)) : r.push(e.call(this));
        }
    return this.eof || this.eat(Qt), {
      type: "Block",
      loc: this.getLocation(n, this.tokenStart),
      children: r
    };
  }
  function as(t) {
    this.token(ut, "{"), this.children(t, (e) => {
      e.type === "Declaration" && this.token(tt, ";");
    }), this.token(Qt, "}");
  }
  const La = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: as,
    name: Ea,
    parse: os,
    structure: Oa,
    walkContext: $a
  }, Symbol.toStringTag, { value: "Module" })), Pa = "Brackets", Ra = {
    children: [[]]
  };
  function ls(t, e) {
    const n = this.tokenStart;
    let r = null;
    return this.eat(te), r = t.call(this, e), this.eof || this.eat(ae), {
      type: "Brackets",
      loc: this.getLocation(n, this.tokenStart),
      children: r
    };
  }
  function cs(t) {
    this.token(L, "["), this.children(t), this.token(L, "]");
  }
  const Ia = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: cs,
    name: Pa,
    parse: ls,
    structure: Ra
  }, Symbol.toStringTag, { value: "Module" })), _a = "CDC", Na = [];
  function us() {
    const t = this.tokenStart;
    return this.eat(et), {
      type: "CDC",
      loc: this.getLocation(t, this.tokenStart)
    };
  }
  function hs() {
    this.token(et, "-->");
  }
  const Da = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: hs,
    name: _a,
    parse: us,
    structure: Na
  }, Symbol.toStringTag, { value: "Module" })), Fa = "CDO", Ma = [];
  function fs() {
    const t = this.tokenStart;
    return this.eat(_e), {
      type: "CDO",
      loc: this.getLocation(t, this.tokenStart)
    };
  }
  function ps() {
    this.token(_e, "<!--");
  }
  const ja = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: ps,
    name: Fa,
    parse: fs,
    structure: Ma
  }, Symbol.toStringTag, { value: "Module" })), Ba = 46, Ua = "ClassSelector", Wa = {
    name: String
  };
  function ds() {
    return this.eatDelim(Ba), {
      type: "ClassSelector",
      loc: this.getLocation(this.tokenStart - 1, this.tokenEnd),
      name: this.consume(d)
    };
  }
  function gs(t) {
    this.token(L, "."), this.token(d, t.name);
  }
  const za = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: gs,
    name: Ua,
    parse: ds,
    structure: Wa
  }, Symbol.toStringTag, { value: "Module" })), Ha = 43, Wn = 47, Va = 62, Ga = 126, qa = "Combinator", Ka = {
    name: String
  };
  function ms() {
    const t = this.tokenStart;
    let e;
    switch (this.tokenType) {
      case U:
        e = " ";
        break;
      case L:
        switch (this.charCodeAt(this.tokenStart)) {
          case Va:
          case Ha:
          case Ga:
            this.next();
            break;
          case Wn:
            this.next(), this.eatIdent("deep"), this.eatDelim(Wn);
            break;
          default:
            this.error("Combinator is expected");
        }
        e = this.substrToCursor(t);
        break;
    }
    return {
      type: "Combinator",
      loc: this.getLocation(t, this.tokenStart),
      name: e
    };
  }
  function ks(t) {
    this.tokenize(t.name);
  }
  const Qa = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: ks,
    name: qa,
    parse: ms,
    structure: Ka
  }, Symbol.toStringTag, { value: "Module" })), Ya = 42, Xa = 47, Ja = "Comment", Za = {
    value: String
  };
  function Ss() {
    const t = this.tokenStart;
    let e = this.tokenEnd;
    return this.eat(Y), e - t + 2 >= 2 && this.charCodeAt(e - 2) === Ya && this.charCodeAt(e - 1) === Xa && (e -= 2), {
      type: "Comment",
      loc: this.getLocation(t, this.tokenStart),
      value: this.substring(t + 2, e)
    };
  }
  function ys(t) {
    this.token(Y, "/*" + t.value + "*/");
  }
  const tl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: ys,
    name: Ja,
    parse: Ss,
    structure: Za
  }, Symbol.toStringTag, { value: "Module" })), el = /* @__PURE__ */ new Set([X, y, Tt]), nl = "Condition", rl = {
    kind: String,
    children: [[
      "Identifier",
      "Feature",
      "FeatureFunction",
      "FeatureRange",
      "SupportsDeclaration"
    ]]
  };
  function zn(t) {
    return this.lookupTypeNonSC(1) === d && el.has(this.lookupTypeNonSC(2)) ? this.Feature(t) : this.FeatureRange(t);
  }
  const sl = {
    media: zn,
    container: zn,
    supports() {
      return this.SupportsDeclaration();
    }
  };
  function bs(t = "media") {
    const e = this.createList();
    t: for (; !this.eof; )
      switch (this.tokenType) {
        case Y:
        case U:
          this.next();
          continue;
        case d:
          e.push(this.Identifier());
          break;
        case I: {
          let n = this.parseWithFallback(
            () => sl[t].call(this, t),
            () => null
          );
          n || (n = this.parseWithFallback(
            () => {
              this.eat(I);
              const r = this.Condition(t);
              return this.eat(y), r;
            },
            () => this.GeneralEnclosed(t)
          )), e.push(n);
          break;
        }
        case A: {
          let n = this.parseWithFallback(
            () => this.FeatureFunction(t),
            () => null
          );
          n || (n = this.GeneralEnclosed(t)), e.push(n);
          break;
        }
        default:
          break t;
      }
    return e.isEmpty && this.error("Condition is expected"), {
      type: "Condition",
      loc: this.getLocationFromList(e),
      kind: t,
      children: e
    };
  }
  function xs(t) {
    t.children.forEach((e) => {
      e.type === "Condition" ? (this.token(I, "("), this.node(e), this.token(y, ")")) : this.node(e);
    });
  }
  const il = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: xs,
    name: nl,
    parse: bs,
    structure: rl
  }, Symbol.toStringTag, { value: "Module" })), Hn = 45;
  function ol(t, e) {
    return e = e || 0, t.length - e >= 2 && t.charCodeAt(e) === Hn && t.charCodeAt(e + 1) === Hn;
  }
  const Cs = 33, al = 35, ll = 36, cl = 38, ul = 42, hl = 43, Vn = 47;
  function fl() {
    return this.Raw(this.consumeUntilExclamationMarkOrSemicolon, !0);
  }
  function pl() {
    return this.Raw(this.consumeUntilExclamationMarkOrSemicolon, !1);
  }
  function dl() {
    const t = this.tokenIndex, e = this.Value();
    return e.type !== "Raw" && this.eof === !1 && this.tokenType !== tt && this.isDelim(Cs) === !1 && this.isBalanceEdge(t) === !1 && this.error(), e;
  }
  const gl = "Declaration", ml = "declaration", kl = {
    important: [Boolean, String],
    property: String,
    value: ["Value", "Raw"]
  };
  function ws() {
    const t = this.tokenStart, e = this.tokenIndex, n = Sl.call(this), r = ol(n), s = r ? this.parseCustomProperty : this.parseValue, o = r ? pl : fl;
    let a = !1, l;
    this.skipSC(), this.eat(X);
    const u = this.tokenIndex;
    if (r || this.skipSC(), s ? l = this.parseWithFallback(dl, o) : l = o.call(this, this.tokenIndex), r && l.type === "Value" && l.children.isEmpty) {
      for (let i = u - this.tokenIndex; i <= 0; i++)
        if (this.lookupType(i) === U) {
          l.children.appendData({
            type: "WhiteSpace",
            loc: null,
            value: " "
          });
          break;
        }
    }
    return this.isDelim(Cs) && (a = yl.call(this), this.skipSC()), this.eof === !1 && this.tokenType !== tt && this.isBalanceEdge(e) === !1 && this.error(), {
      type: "Declaration",
      loc: this.getLocation(t, this.tokenStart),
      important: a,
      property: n,
      value: l
    };
  }
  function As(t) {
    this.token(d, t.property), this.token(X, ":"), this.node(t.value), t.important && (this.token(L, "!"), this.token(d, t.important === !0 ? "important" : t.important));
  }
  function Sl() {
    const t = this.tokenStart;
    if (this.tokenType === L)
      switch (this.charCodeAt(this.tokenStart)) {
        case ul:
        case ll:
        case hl:
        case al:
        case cl:
          this.next();
          break;
        // TODO: not sure we should support this hack
        case Vn:
          this.next(), this.isDelim(Vn) && this.next();
          break;
      }
    return this.tokenType === N ? this.eat(N) : this.eat(d), this.substrToCursor(t);
  }
  function yl() {
    this.eat(L), this.skipSC();
    const t = this.consume(d);
    return t === "important" ? !0 : t;
  }
  const bl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: As,
    name: gl,
    parse: ws,
    structure: kl,
    walkContext: ml
  }, Symbol.toStringTag, { value: "Module" })), xl = 38;
  function We() {
    return this.Raw(this.consumeUntilSemicolonIncluded, !0);
  }
  const Cl = "DeclarationList", wl = {
    children: [[
      "Declaration",
      "Atrule",
      "Rule"
    ]]
  };
  function Ts() {
    const t = this.createList();
    for (; !this.eof; )
      switch (this.tokenType) {
        case U:
        case Y:
        case tt:
          this.next();
          break;
        case z:
          t.push(this.parseWithFallback(this.Atrule.bind(this, !0), We));
          break;
        default:
          this.isDelim(xl) ? t.push(this.parseWithFallback(this.Rule, We)) : t.push(this.parseWithFallback(this.Declaration, We));
      }
    return {
      type: "DeclarationList",
      loc: this.getLocationFromList(t),
      children: t
    };
  }
  function vs(t) {
    this.children(t, (e) => {
      e.type === "Declaration" && this.token(tt, ";");
    });
  }
  const Al = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: vs,
    name: Cl,
    parse: Ts,
    structure: wl
  }, Symbol.toStringTag, { value: "Module" })), Tl = "Dimension", vl = {
    value: String,
    unit: String
  };
  function Es() {
    const t = this.tokenStart, e = this.consumeNumber($);
    return {
      type: "Dimension",
      loc: this.getLocation(t, this.tokenStart),
      value: e,
      unit: this.substring(t + e.length, this.tokenStart)
    };
  }
  function $s(t) {
    this.token($, t.value + t.unit);
  }
  const El = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: $s,
    name: Tl,
    parse: Es,
    structure: vl
  }, Symbol.toStringTag, { value: "Module" })), $l = 47, Ol = "Feature", Ll = {
    kind: String,
    name: String,
    value: ["Identifier", "Number", "Dimension", "Ratio", "Function", null]
  };
  function Os(t) {
    const e = this.tokenStart;
    let n, r = null;
    if (this.eat(I), this.skipSC(), n = this.consume(d), this.skipSC(), this.tokenType !== y) {
      switch (this.eat(X), this.skipSC(), this.tokenType) {
        case x:
          this.lookupNonWSType(1) === L ? r = this.Ratio() : r = this.Number();
          break;
        case $:
          r = this.Dimension();
          break;
        case d:
          r = this.Identifier();
          break;
        case A:
          r = this.parseWithFallback(
            () => {
              const s = this.Function(this.readSequence, this.scope.Value);
              return this.skipSC(), this.isDelim($l) && this.error(), s;
            },
            () => this.Ratio()
          );
          break;
        default:
          this.error("Number, dimension, ratio or identifier is expected");
      }
      this.skipSC();
    }
    return this.eof || this.eat(y), {
      type: "Feature",
      loc: this.getLocation(e, this.tokenStart),
      kind: t,
      name: n,
      value: r
    };
  }
  function Ls(t) {
    this.token(I, "("), this.token(d, t.name), t.value !== null && (this.token(X, ":"), this.node(t.value)), this.token(y, ")");
  }
  const Pl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: Ls,
    name: Ol,
    parse: Os,
    structure: Ll
  }, Symbol.toStringTag, { value: "Module" })), Rl = "FeatureFunction", Il = {
    kind: String,
    feature: String,
    value: ["Declaration", "Selector"]
  };
  function _l(t, e) {
    const r = (this.features[t] || {})[e];
    return typeof r != "function" && this.error(`Unknown feature ${e}()`), r;
  }
  function Ps(t = "unknown") {
    const e = this.tokenStart, n = this.consumeFunctionName(), r = _l.call(this, t, n.toLowerCase());
    this.skipSC();
    const s = this.parseWithFallback(
      () => {
        const o = this.tokenIndex, a = r.call(this);
        return this.eof === !1 && this.isBalanceEdge(o) === !1 && this.error(), a;
      },
      () => this.Raw(null, !1)
    );
    return this.eof || this.eat(y), {
      type: "FeatureFunction",
      loc: this.getLocation(e, this.tokenStart),
      kind: t,
      feature: n,
      value: s
    };
  }
  function Rs(t) {
    this.token(A, t.feature + "("), this.node(t.value), this.token(y, ")");
  }
  const Nl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: Rs,
    name: Rl,
    parse: Ps,
    structure: Il
  }, Symbol.toStringTag, { value: "Module" })), Gn = 47, Dl = 60, qn = 61, Fl = 62, Ml = "FeatureRange", jl = {
    kind: String,
    left: ["Identifier", "Number", "Dimension", "Ratio", "Function"],
    leftComparison: String,
    middle: ["Identifier", "Number", "Dimension", "Ratio", "Function"],
    rightComparison: [String, null],
    right: ["Identifier", "Number", "Dimension", "Ratio", "Function", null]
  };
  function ze() {
    switch (this.skipSC(), this.tokenType) {
      case x:
        return this.isDelim(Gn, this.lookupOffsetNonSC(1)) ? this.Ratio() : this.Number();
      case $:
        return this.Dimension();
      case d:
        return this.Identifier();
      case A:
        return this.parseWithFallback(
          () => {
            const t = this.Function(this.readSequence, this.scope.Value);
            return this.skipSC(), this.isDelim(Gn) && this.error(), t;
          },
          () => this.Ratio()
        );
      default:
        this.error("Number, dimension, ratio or identifier is expected");
    }
  }
  function Kn(t) {
    if (this.skipSC(), this.isDelim(Dl) || this.isDelim(Fl)) {
      const e = this.source[this.tokenStart];
      return this.next(), this.isDelim(qn) ? (this.next(), e + "=") : e;
    }
    if (this.isDelim(qn))
      return "=";
    this.error(`Expected ${t ? '":", ' : ""}"<", ">", "=" or ")"`);
  }
  function Is(t = "unknown") {
    const e = this.tokenStart;
    this.skipSC(), this.eat(I);
    const n = ze.call(this), r = Kn.call(this, n.type === "Identifier"), s = ze.call(this);
    let o = null, a = null;
    return this.lookupNonWSType(0) !== y && (o = Kn.call(this), a = ze.call(this)), this.skipSC(), this.eat(y), {
      type: "FeatureRange",
      loc: this.getLocation(e, this.tokenStart),
      kind: t,
      left: n,
      leftComparison: r,
      middle: s,
      rightComparison: o,
      right: a
    };
  }
  function _s(t) {
    this.token(I, "("), this.node(t.left), this.tokenize(t.leftComparison), this.node(t.middle), t.right && (this.tokenize(t.rightComparison), this.node(t.right)), this.token(y, ")");
  }
  const Bl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: _s,
    name: Ml,
    parse: Is,
    structure: jl
  }, Symbol.toStringTag, { value: "Module" })), Ul = "Function", Wl = "function", zl = {
    name: String,
    children: [[]]
  };
  function Ns(t, e) {
    const n = this.tokenStart, r = this.consumeFunctionName(), s = r.toLowerCase();
    let o;
    return o = e.hasOwnProperty(s) ? e[s].call(this, e) : t.call(this, e), this.eof || this.eat(y), {
      type: "Function",
      loc: this.getLocation(n, this.tokenStart),
      name: r,
      children: o
    };
  }
  function Ds(t) {
    this.token(A, t.name + "("), this.children(t), this.token(y, ")");
  }
  const Hl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: Ds,
    name: Ul,
    parse: Ns,
    structure: zl,
    walkContext: Wl
  }, Symbol.toStringTag, { value: "Module" })), Vl = "GeneralEnclosed", Gl = {
    kind: String,
    function: [String, null],
    children: [[]]
  };
  function Fs(t) {
    const e = this.tokenStart;
    let n = null;
    this.tokenType === A ? n = this.consumeFunctionName() : this.eat(I);
    const r = this.parseWithFallback(
      () => {
        const s = this.tokenIndex, o = this.readSequence(this.scope.Value);
        return this.eof === !1 && this.isBalanceEdge(s) === !1 && this.error(), o;
      },
      () => this.createSingleNodeList(
        this.Raw(null, !1)
      )
    );
    return this.eof || this.eat(y), {
      type: "GeneralEnclosed",
      loc: this.getLocation(e, this.tokenStart),
      kind: t,
      function: n,
      children: r
    };
  }
  function Ms(t) {
    t.function ? this.token(A, t.function + "(") : this.token(I, "("), this.children(t), this.token(y, ")");
  }
  const ql = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: Ms,
    name: Vl,
    parse: Fs,
    structure: Gl
  }, Symbol.toStringTag, { value: "Module" })), Kl = "XXX", Ql = "Hash", Yl = {
    value: String
  };
  function js() {
    const t = this.tokenStart;
    return this.eat(N), {
      type: "Hash",
      loc: this.getLocation(t, this.tokenStart),
      value: this.substrToCursor(t + 1)
    };
  }
  function Bs(t) {
    this.token(N, "#" + t.value);
  }
  const Xl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: Bs,
    name: Ql,
    parse: js,
    structure: Yl,
    xxx: Kl
  }, Symbol.toStringTag, { value: "Module" })), Jl = "Identifier", Zl = {
    name: String
  };
  function Us() {
    return {
      type: "Identifier",
      loc: this.getLocation(this.tokenStart, this.tokenEnd),
      name: this.consume(d)
    };
  }
  function Ws(t) {
    this.token(d, t.name);
  }
  const tc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: Ws,
    name: Jl,
    parse: Us,
    structure: Zl
  }, Symbol.toStringTag, { value: "Module" })), ec = "IdSelector", nc = {
    name: String
  };
  function zs() {
    const t = this.tokenStart;
    return this.eat(N), {
      type: "IdSelector",
      loc: this.getLocation(t, this.tokenStart),
      name: this.substrToCursor(t + 1)
    };
  }
  function Hs(t) {
    this.token(L, "#" + t.name);
  }
  const rc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: Hs,
    name: ec,
    parse: zs,
    structure: nc
  }, Symbol.toStringTag, { value: "Module" })), sc = 46, ic = "Layer", oc = {
    name: String
  };
  function Vs() {
    let t = this.tokenStart, e = this.consume(d);
    for (; this.isDelim(sc); )
      this.eat(L), e += "." + this.consume(d);
    return {
      type: "Layer",
      loc: this.getLocation(t, this.tokenStart),
      name: e
    };
  }
  function Gs(t) {
    this.tokenize(t.name);
  }
  const ac = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: Gs,
    name: ic,
    parse: Vs,
    structure: oc
  }, Symbol.toStringTag, { value: "Module" })), lc = "LayerList", cc = {
    children: [[
      "Layer"
    ]]
  };
  function qs() {
    const t = this.createList();
    for (this.skipSC(); !this.eof && (t.push(this.Layer()), this.lookupTypeNonSC(0) === ht); )
      this.skipSC(), this.next(), this.skipSC();
    return {
      type: "LayerList",
      loc: this.getLocationFromList(t),
      children: t
    };
  }
  function Ks(t) {
    this.children(t, () => this.token(ht, ","));
  }
  const uc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: Ks,
    name: lc,
    parse: qs,
    structure: cc
  }, Symbol.toStringTag, { value: "Module" })), hc = "MediaQuery", fc = {
    modifier: [String, null],
    mediaType: [String, null],
    condition: ["Condition", null]
  };
  function Qs() {
    const t = this.tokenStart;
    let e = null, n = null, r = null;
    if (this.skipSC(), this.tokenType === d && this.lookupTypeNonSC(1) !== I) {
      const s = this.consume(d), o = s.toLowerCase();
      switch (o === "not" || o === "only" ? (this.skipSC(), e = o, n = this.consume(d)) : n = s, this.lookupTypeNonSC(0)) {
        case d: {
          this.skipSC(), this.eatIdent("and"), r = this.Condition("media");
          break;
        }
        case ut:
        case tt:
        case ht:
        case Tt:
          break;
        default:
          this.error("Identifier or parenthesis is expected");
      }
    } else
      switch (this.tokenType) {
        case d:
        case I:
        case A: {
          r = this.Condition("media");
          break;
        }
        case ut:
        case tt:
        case Tt:
          break;
        default:
          this.error("Identifier or parenthesis is expected");
      }
    return {
      type: "MediaQuery",
      loc: this.getLocation(t, this.tokenStart),
      modifier: e,
      mediaType: n,
      condition: r
    };
  }
  function Ys(t) {
    t.mediaType ? (t.modifier && this.token(d, t.modifier), this.token(d, t.mediaType), t.condition && (this.token(d, "and"), this.node(t.condition))) : t.condition && this.node(t.condition);
  }
  const pc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: Ys,
    name: hc,
    parse: Qs,
    structure: fc
  }, Symbol.toStringTag, { value: "Module" })), dc = "MediaQueryList", gc = {
    children: [[
      "MediaQuery"
    ]]
  };
  function Xs() {
    const t = this.createList();
    for (this.skipSC(); !this.eof && (t.push(this.MediaQuery()), this.tokenType === ht); )
      this.next();
    return {
      type: "MediaQueryList",
      loc: this.getLocationFromList(t),
      children: t
    };
  }
  function Js(t) {
    this.children(t, () => this.token(ht, ","));
  }
  const mc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: Js,
    name: dc,
    parse: Xs,
    structure: gc
  }, Symbol.toStringTag, { value: "Module" })), kc = 38, Sc = "NestingSelector", yc = {};
  function Zs() {
    const t = this.tokenStart;
    return this.eatDelim(kc), {
      type: "NestingSelector",
      loc: this.getLocation(t, this.tokenStart)
    };
  }
  function ti() {
    this.token(L, "&");
  }
  const bc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: ti,
    name: Sc,
    parse: Zs,
    structure: yc
  }, Symbol.toStringTag, { value: "Module" })), xc = "Nth", Cc = {
    nth: ["AnPlusB", "Identifier"],
    selector: ["SelectorList", null]
  };
  function ei() {
    this.skipSC();
    const t = this.tokenStart;
    let e = t, n = null, r;
    return this.lookupValue(0, "odd") || this.lookupValue(0, "even") ? r = this.Identifier() : r = this.AnPlusB(), e = this.tokenStart, this.skipSC(), this.lookupValue(0, "of") && (this.next(), n = this.SelectorList(), e = this.tokenStart), {
      type: "Nth",
      loc: this.getLocation(t, e),
      nth: r,
      selector: n
    };
  }
  function ni(t) {
    this.node(t.nth), t.selector !== null && (this.token(d, "of"), this.node(t.selector));
  }
  const wc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: ni,
    name: xc,
    parse: ei,
    structure: Cc
  }, Symbol.toStringTag, { value: "Module" })), Ac = "Number", Tc = {
    value: String
  };
  function ri() {
    return {
      type: "Number",
      loc: this.getLocation(this.tokenStart, this.tokenEnd),
      value: this.consume(x)
    };
  }
  function si(t) {
    this.token(x, t.value);
  }
  const vc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: si,
    name: Ac,
    parse: ri,
    structure: Tc
  }, Symbol.toStringTag, { value: "Module" })), Ec = "Operator", $c = {
    value: String
  };
  function ii() {
    const t = this.tokenStart;
    return this.next(), {
      type: "Operator",
      loc: this.getLocation(t, this.tokenStart),
      value: this.substrToCursor(t)
    };
  }
  function oi(t) {
    this.tokenize(t.value);
  }
  const Oc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: oi,
    name: Ec,
    parse: ii,
    structure: $c
  }, Symbol.toStringTag, { value: "Module" })), Lc = "Parentheses", Pc = {
    children: [[]]
  };
  function ai(t, e) {
    const n = this.tokenStart;
    let r = null;
    return this.eat(I), r = t.call(this, e), this.eof || this.eat(y), {
      type: "Parentheses",
      loc: this.getLocation(n, this.tokenStart),
      children: r
    };
  }
  function li(t) {
    this.token(I, "("), this.children(t), this.token(y, ")");
  }
  const Rc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: li,
    name: Lc,
    parse: ai,
    structure: Pc
  }, Symbol.toStringTag, { value: "Module" })), Ic = "Percentage", _c = {
    value: String
  };
  function ci() {
    return {
      type: "Percentage",
      loc: this.getLocation(this.tokenStart, this.tokenEnd),
      value: this.consumeNumber(F)
    };
  }
  function ui(t) {
    this.token(F, t.value + "%");
  }
  const Nc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: ui,
    name: Ic,
    parse: ci,
    structure: _c
  }, Symbol.toStringTag, { value: "Module" })), Dc = "PseudoClassSelector", Fc = "function", Mc = {
    name: String,
    children: [["Raw"], null]
  };
  function hi() {
    const t = this.tokenStart;
    let e = null, n, r;
    return this.eat(X), this.tokenType === A ? (n = this.consumeFunctionName(), r = n.toLowerCase(), this.lookupNonWSType(0) == y ? e = this.createList() : hasOwnProperty.call(this.pseudo, r) ? (this.skipSC(), e = this.pseudo[r].call(this), this.skipSC()) : (e = this.createList(), e.push(
      this.Raw(null, !1)
    )), this.eat(y)) : n = this.consume(d), {
      type: "PseudoClassSelector",
      loc: this.getLocation(t, this.tokenStart),
      name: n,
      children: e
    };
  }
  function fi(t) {
    this.token(X, ":"), t.children === null ? this.token(d, t.name) : (this.token(A, t.name + "("), this.children(t), this.token(y, ")"));
  }
  const jc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: fi,
    name: Dc,
    parse: hi,
    structure: Mc,
    walkContext: Fc
  }, Symbol.toStringTag, { value: "Module" })), Bc = "PseudoElementSelector", Uc = "function", Wc = {
    name: String,
    children: [["Raw"], null]
  };
  function pi() {
    const t = this.tokenStart;
    let e = null, n, r;
    return this.eat(X), this.eat(X), this.tokenType === A ? (n = this.consumeFunctionName(), r = n.toLowerCase(), this.lookupNonWSType(0) == y ? e = this.createList() : hasOwnProperty.call(this.pseudo, r) ? (this.skipSC(), e = this.pseudo[r].call(this), this.skipSC()) : (e = this.createList(), e.push(
      this.Raw(null, !1)
    )), this.eat(y)) : n = this.consume(d), {
      type: "PseudoElementSelector",
      loc: this.getLocation(t, this.tokenStart),
      name: n,
      children: e
    };
  }
  function di(t) {
    this.token(X, ":"), this.token(X, ":"), t.children === null ? this.token(d, t.name) : (this.token(A, t.name + "("), this.children(t), this.token(y, ")"));
  }
  const zc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: di,
    name: Bc,
    parse: pi,
    structure: Wc,
    walkContext: Uc
  }, Symbol.toStringTag, { value: "Module" })), Qn = 47;
  function Yn() {
    switch (this.skipSC(), this.tokenType) {
      case x:
        return this.Number();
      case A:
        return this.Function(this.readSequence, this.scope.Value);
      default:
        this.error("Number of function is expected");
    }
  }
  const Hc = "Ratio", Vc = {
    left: ["Number", "Function"],
    right: ["Number", "Function", null]
  };
  function gi() {
    const t = this.tokenStart, e = Yn.call(this);
    let n = null;
    return this.skipSC(), this.isDelim(Qn) && (this.eatDelim(Qn), n = Yn.call(this)), {
      type: "Ratio",
      loc: this.getLocation(t, this.tokenStart),
      left: e,
      right: n
    };
  }
  function mi(t) {
    this.node(t.left), this.token(L, "/"), t.right ? this.node(t.right) : this.node(x, 1);
  }
  const Gc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: mi,
    name: Hc,
    parse: gi,
    structure: Vc
  }, Symbol.toStringTag, { value: "Module" }));
  function qc() {
    return this.tokenIndex > 0 && this.lookupType(-1) === U ? this.tokenIndex > 1 ? this.getTokenStart(this.tokenIndex - 1) : this.firstCharOffset : this.tokenStart;
  }
  const Kc = "Raw", Qc = {
    value: String
  };
  function ki(t, e) {
    const n = this.getTokenStart(this.tokenIndex);
    let r;
    return this.skipUntilBalanced(this.tokenIndex, t || this.consumeUntilBalanceEnd), e && this.tokenStart > n ? r = qc.call(this) : r = this.tokenStart, {
      type: "Raw",
      loc: this.getLocation(n, r),
      value: this.substring(n, r)
    };
  }
  function Si(t) {
    this.tokenize(t.value);
  }
  const Yc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: Si,
    name: Kc,
    parse: ki,
    structure: Qc
  }, Symbol.toStringTag, { value: "Module" }));
  function Xn() {
    return this.Raw(this.consumeUntilLeftCurlyBracket, !0);
  }
  function Xc() {
    const t = this.SelectorList();
    return t.type !== "Raw" && this.eof === !1 && this.tokenType !== ut && this.error(), t;
  }
  const Jc = "Rule", Zc = "rule", tu = {
    prelude: ["SelectorList", "Raw"],
    block: ["Block"]
  };
  function yi() {
    const t = this.tokenIndex, e = this.tokenStart;
    let n, r;
    return this.parseRulePrelude ? n = this.parseWithFallback(Xc, Xn) : n = Xn.call(this, t), r = this.Block(!0), {
      type: "Rule",
      loc: this.getLocation(e, this.tokenStart),
      prelude: n,
      block: r
    };
  }
  function bi(t) {
    this.node(t.prelude), this.node(t.block);
  }
  const eu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: bi,
    name: Jc,
    parse: yi,
    structure: tu,
    walkContext: Zc
  }, Symbol.toStringTag, { value: "Module" })), nu = "Scope", ru = {
    root: ["SelectorList", "Raw", null],
    limit: ["SelectorList", "Raw", null]
  };
  function xi() {
    let t = null, e = null;
    this.skipSC();
    const n = this.tokenStart;
    return this.tokenType === I && (this.next(), this.skipSC(), t = this.parseWithFallback(
      this.SelectorList,
      () => this.Raw(!1, !0)
    ), this.skipSC(), this.eat(y)), this.lookupNonWSType(0) === d && (this.skipSC(), this.eatIdent("to"), this.skipSC(), this.eat(I), this.skipSC(), e = this.parseWithFallback(
      this.SelectorList,
      () => this.Raw(!1, !0)
    ), this.skipSC(), this.eat(y)), {
      type: "Scope",
      loc: this.getLocation(n, this.tokenStart),
      root: t,
      limit: e
    };
  }
  function Ci(t) {
    t.root && (this.token(I, "("), this.node(t.root), this.token(y, ")")), t.limit && (this.token(d, "to"), this.token(I, "("), this.node(t.limit), this.token(y, ")"));
  }
  const su = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: Ci,
    name: nu,
    parse: xi,
    structure: ru
  }, Symbol.toStringTag, { value: "Module" })), iu = "Selector", ou = {
    children: [[
      "TypeSelector",
      "IdSelector",
      "ClassSelector",
      "AttributeSelector",
      "PseudoClassSelector",
      "PseudoElementSelector",
      "Combinator"
    ]]
  };
  function wi() {
    const t = this.readSequence(this.scope.Selector);
    return this.getFirstListNode(t) === null && this.error("Selector is expected"), {
      type: "Selector",
      loc: this.getLocationFromList(t),
      children: t
    };
  }
  function Ai(t) {
    this.children(t);
  }
  const au = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: Ai,
    name: iu,
    parse: wi,
    structure: ou
  }, Symbol.toStringTag, { value: "Module" })), lu = "SelectorList", cu = "selector", uu = {
    children: [[
      "Selector",
      "Raw"
    ]]
  };
  function Ti() {
    const t = this.createList();
    for (; !this.eof; ) {
      if (t.push(this.Selector()), this.tokenType === ht) {
        this.next();
        continue;
      }
      break;
    }
    return {
      type: "SelectorList",
      loc: this.getLocationFromList(t),
      children: t
    };
  }
  function vi(t) {
    this.children(t, () => this.token(ht, ","));
  }
  const hu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: vi,
    name: lu,
    parse: Ti,
    structure: uu,
    walkContext: cu
  }, Symbol.toStringTag, { value: "Module" })), an = 92, Ei = 34, fu = 39;
  function $i(t) {
    const e = t.length, n = t.charCodeAt(0), r = n === Ei || n === fu ? 1 : 0, s = r === 1 && e > 1 && t.charCodeAt(e - 1) === n ? e - 2 : e - 1;
    let o = "";
    for (let a = r; a <= s; a++) {
      let l = t.charCodeAt(a);
      if (l === an) {
        if (a === s) {
          a !== e - 1 && (o = t.substr(a + 1));
          break;
        }
        if (l = t.charCodeAt(++a), mt(an, l)) {
          const u = a - 1, i = Xt(t, u);
          a = i - 1, o += qr(t.substring(u + 1, i));
        } else
          l === 13 && t.charCodeAt(a + 1) === 10 && a++;
      } else
        o += t[a];
    }
    return o;
  }
  function pu(t, e) {
    const n = '"', r = Ei;
    let s = "", o = !1;
    for (let a = 0; a < t.length; a++) {
      const l = t.charCodeAt(a);
      if (l === 0) {
        s += "�";
        continue;
      }
      if (l <= 31 || l === 127) {
        s += "\\" + l.toString(16), o = !0;
        continue;
      }
      l === r || l === an ? (s += "\\" + t.charAt(a), o = !1) : (o && (Yt(l) || Dt(l)) && (s += " "), s += t.charAt(a), o = !1);
    }
    return n + s + n;
  }
  const du = "String", gu = {
    value: String
  };
  function Oi() {
    return {
      type: "String",
      loc: this.getLocation(this.tokenStart, this.tokenEnd),
      value: $i(this.consume(wt))
    };
  }
  function Li(t) {
    this.token(wt, pu(t.value));
  }
  const mu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: Li,
    name: du,
    parse: Oi,
    structure: gu
  }, Symbol.toStringTag, { value: "Module" })), ku = 33;
  function Jn() {
    return this.Raw(null, !1);
  }
  const Su = "StyleSheet", yu = "stylesheet", bu = {
    children: [[
      "Comment",
      "CDO",
      "CDC",
      "Atrule",
      "Rule",
      "Raw"
    ]]
  };
  function Pi() {
    const t = this.tokenStart, e = this.createList();
    let n;
    for (; !this.eof; ) {
      switch (this.tokenType) {
        case U:
          this.next();
          continue;
        case Y:
          if (this.charCodeAt(this.tokenStart + 2) !== ku) {
            this.next();
            continue;
          }
          n = this.Comment();
          break;
        case _e:
          n = this.CDO();
          break;
        case et:
          n = this.CDC();
          break;
        // CSS Syntax Module Level 3
        // §2.2 Error handling
        // At the "top level" of a stylesheet, an <at-keyword-token> starts an at-rule.
        case z:
          n = this.parseWithFallback(this.Atrule, Jn);
          break;
        // Anything else starts a qualified rule ...
        default:
          n = this.parseWithFallback(this.Rule, Jn);
      }
      e.push(n);
    }
    return {
      type: "StyleSheet",
      loc: this.getLocation(t, this.tokenStart),
      children: e
    };
  }
  function Ri(t) {
    this.children(t);
  }
  const xu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: Ri,
    name: Su,
    parse: Pi,
    structure: bu,
    walkContext: yu
  }, Symbol.toStringTag, { value: "Module" })), Cu = "SupportsDeclaration", wu = {
    declaration: "Declaration"
  };
  function Ii() {
    const t = this.tokenStart;
    this.eat(I), this.skipSC();
    const e = this.Declaration();
    return this.eof || this.eat(y), {
      type: "SupportsDeclaration",
      loc: this.getLocation(t, this.tokenStart),
      declaration: e
    };
  }
  function _i(t) {
    this.token(I, "("), this.node(t.declaration), this.token(y, ")");
  }
  const Au = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: _i,
    name: Cu,
    parse: Ii,
    structure: wu
  }, Symbol.toStringTag, { value: "Module" })), Tu = 42, Zn = 124;
  function He() {
    this.tokenType !== d && this.isDelim(Tu) === !1 && this.error("Identifier or asterisk is expected"), this.next();
  }
  const vu = "TypeSelector", Eu = {
    name: String
  };
  function Ni() {
    const t = this.tokenStart;
    return this.isDelim(Zn) ? (this.next(), He.call(this)) : (He.call(this), this.isDelim(Zn) && (this.next(), He.call(this))), {
      type: "TypeSelector",
      loc: this.getLocation(t, this.tokenStart),
      name: this.substrToCursor(t)
    };
  }
  function Di(t) {
    this.tokenize(t.name);
  }
  const $u = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: Di,
    name: vu,
    parse: Ni,
    structure: Eu
  }, Symbol.toStringTag, { value: "Module" })), Fi = 43, Mi = 45, ln = 63;
  function ne(t, e) {
    let n = 0;
    for (let r = this.tokenStart + t; r < this.tokenEnd; r++) {
      const s = this.charCodeAt(r);
      if (s === Mi && e && n !== 0)
        return ne.call(this, t + n + 1, !1), -1;
      Yt(s) || this.error(
        e && n !== 0 ? "Hyphen minus" + (n < 6 ? " or hex digit" : "") + " is expected" : n < 6 ? "Hex digit is expected" : "Unexpected input",
        r
      ), ++n > 6 && this.error("Too many hex digits", r);
    }
    return this.next(), n;
  }
  function ge(t) {
    let e = 0;
    for (; this.isDelim(ln); )
      ++e > t && this.error("Too many question marks"), this.next();
  }
  function Ou(t) {
    this.charCodeAt(this.tokenStart) !== t && this.error((t === Fi ? "Plus sign" : "Hyphen minus") + " is expected");
  }
  function Lu() {
    let t = 0;
    switch (this.tokenType) {
      case x:
        if (t = ne.call(this, 1, !0), this.isDelim(ln)) {
          ge.call(this, 6 - t);
          break;
        }
        if (this.tokenType === $ || this.tokenType === x) {
          Ou.call(this, Mi), ne.call(this, 1, !1);
          break;
        }
        break;
      case $:
        t = ne.call(this, 1, !0), t > 0 && ge.call(this, 6 - t);
        break;
      default:
        if (this.eatDelim(Fi), this.tokenType === d) {
          t = ne.call(this, 0, !0), t > 0 && ge.call(this, 6 - t);
          break;
        }
        if (this.isDelim(ln)) {
          this.next(), ge.call(this, 5);
          break;
        }
        this.error("Hex digit or question mark is expected");
    }
  }
  const Pu = "UnicodeRange", Ru = {
    value: String
  };
  function ji() {
    const t = this.tokenStart;
    return this.eatIdent("u"), Lu.call(this), {
      type: "UnicodeRange",
      loc: this.getLocation(t, this.tokenStart),
      value: this.substrToCursor(t)
    };
  }
  function Bi(t) {
    this.tokenize(t.value);
  }
  const Iu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: Bi,
    name: Pu,
    parse: ji,
    structure: Ru
  }, Symbol.toStringTag, { value: "Module" })), _u = 32, cn = 92, Nu = 34, Du = 39, Fu = 40, Ui = 41;
  function Mu(t) {
    const e = t.length;
    let n = 4, r = t.charCodeAt(e - 1) === Ui ? e - 2 : e - 1, s = "";
    for (; n < r && Dt(t.charCodeAt(n)); )
      n++;
    for (; n < r && Dt(t.charCodeAt(r)); )
      r--;
    for (let o = n; o <= r; o++) {
      let a = t.charCodeAt(o);
      if (a === cn) {
        if (o === r) {
          o !== e - 1 && (s = t.substr(o + 1));
          break;
        }
        if (a = t.charCodeAt(++o), mt(cn, a)) {
          const l = o - 1, u = Xt(t, l);
          o = u - 1, s += qr(t.substring(l + 1, u));
        } else
          a === 13 && t.charCodeAt(o + 1) === 10 && o++;
      } else
        s += t[o];
    }
    return s;
  }
  function ju(t) {
    let e = "", n = !1;
    for (let r = 0; r < t.length; r++) {
      const s = t.charCodeAt(r);
      if (s === 0) {
        e += "�";
        continue;
      }
      if (s <= 31 || s === 127) {
        e += "\\" + s.toString(16), n = !0;
        continue;
      }
      s === _u || s === cn || s === Nu || s === Du || s === Fu || s === Ui ? (e += "\\" + t.charAt(r), n = !1) : (n && Yt(s) && (e += " "), e += t.charAt(r), n = !1);
    }
    return "url(" + e + ")";
  }
  const Bu = "Url", Uu = {
    value: String
  };
  function Wi() {
    const t = this.tokenStart;
    let e;
    switch (this.tokenType) {
      case Q:
        e = Mu(this.consume(Q));
        break;
      case A:
        this.cmpStr(this.tokenStart, this.tokenEnd, "url(") || this.error("Function name must be `url`"), this.eat(A), this.skipSC(), e = $i(this.consume(wt)), this.skipSC(), this.eof || this.eat(y);
        break;
      default:
        this.error("Url or Function is expected");
    }
    return {
      type: "Url",
      loc: this.getLocation(t, this.tokenStart),
      value: e
    };
  }
  function zi(t) {
    this.token(Q, ju(t.value));
  }
  const Wu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: zi,
    name: Bu,
    parse: Wi,
    structure: Uu
  }, Symbol.toStringTag, { value: "Module" })), zu = "Value", Hu = {
    children: [[]]
  };
  function Hi() {
    const t = this.tokenStart, e = this.readSequence(this.scope.Value);
    return {
      type: "Value",
      loc: this.getLocation(t, this.tokenStart),
      children: e
    };
  }
  function Vi(t) {
    this.children(t);
  }
  const Vu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: Vi,
    name: zu,
    parse: Hi,
    structure: Hu
  }, Symbol.toStringTag, { value: "Module" })), Gu = Object.freeze({
    type: "WhiteSpace",
    loc: null,
    value: " "
  }), qu = "WhiteSpace", Ku = {
    value: String
  };
  function Gi() {
    return this.eat(U), Gu;
  }
  function qi(t) {
    this.token(U, t.value);
  }
  const Qu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    generate: qi,
    name: qu,
    parse: Gi,
    structure: Ku
  }, Symbol.toStringTag, { value: "Module" })), Yu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    AnPlusB: aa,
    Atrule: fa,
    AtrulePrelude: ma,
    AttributeSelector: Aa,
    Block: La,
    Brackets: Ia,
    CDC: Da,
    CDO: ja,
    ClassSelector: za,
    Combinator: Qa,
    Comment: tl,
    Condition: il,
    Declaration: bl,
    DeclarationList: Al,
    Dimension: El,
    Feature: Pl,
    FeatureFunction: Nl,
    FeatureRange: Bl,
    Function: Hl,
    GeneralEnclosed: ql,
    Hash: Xl,
    IdSelector: rc,
    Identifier: tc,
    Layer: ac,
    LayerList: uc,
    MediaQuery: pc,
    MediaQueryList: mc,
    NestingSelector: bc,
    Nth: wc,
    Number: vc,
    Operator: Oc,
    Parentheses: Rc,
    Percentage: Nc,
    PseudoClassSelector: jc,
    PseudoElementSelector: zc,
    Ratio: Gc,
    Raw: Yc,
    Rule: eu,
    Scope: su,
    Selector: au,
    SelectorList: hu,
    String: mu,
    StyleSheet: xu,
    SupportsDeclaration: Au,
    TypeSelector: $u,
    UnicodeRange: Iu,
    Url: Wu,
    Value: Vu,
    WhiteSpace: Qu
  }, Symbol.toStringTag, { value: "Module" })), Xu = {
    node: Yu
  }, Et = Vo(Xu), Cn = [
    "left",
    "right",
    "top",
    "bottom",
    "inset-block-start",
    "inset-block-end",
    "inset-inline-start",
    "inset-inline-end",
    "inset-block",
    "inset-inline",
    "inset"
  ];
  function le(t) {
    return Cn.includes(t);
  }
  const wn = [
    "margin-block-start",
    "margin-block-end",
    "margin-block",
    "margin-inline-start",
    "margin-inline-end",
    "margin-inline",
    "margin-bottom",
    "margin-left",
    "margin-right",
    "margin-top",
    "margin"
  ];
  function Ju(t) {
    return wn.includes(t);
  }
  const An = [
    "width",
    "height",
    "min-width",
    "min-height",
    "max-width",
    "max-height",
    "block-size",
    "inline-size",
    "min-block-size",
    "min-inline-size",
    "max-block-size",
    "max-inline-size"
  ];
  function Ki(t) {
    return An.includes(t);
  }
  const Qi = [
    "justify-self",
    "align-self",
    "place-self"
  ];
  function Zu(t) {
    return Qi.includes(t);
  }
  const Yi = [
    ...Cn,
    ...wn,
    ...An,
    ...Qi,
    "position-anchor",
    "position-area"
  ], th = [
    ...An,
    ...Cn,
    ...wn
  ];
  function Xi(t) {
    return th.includes(
      t
    );
  }
  const eh = [
    "top",
    "left",
    "right",
    "bottom",
    "start",
    "end",
    "self-start",
    "self-end",
    "center",
    "inside",
    "outside"
  ];
  function Ji(t) {
    return eh.includes(t);
  }
  const nh = [
    "width",
    "height",
    "block",
    "inline",
    "self-block",
    "self-inline"
  ];
  function rh(t) {
    return nh.includes(t);
  }
  const tr = /* @__PURE__ */ new Set(["Atrule", "Selector", "Declaration"]);
  function sh(t) {
    const e = new SourceMapGenerator(), n = {
      line: 1,
      column: 0
    }, r = {
      line: 0,
      // should be zero to add first mapping
      column: 0
    }, s = {
      line: 1,
      column: 0
    }, o = {
      generated: s
    };
    let a = 1, l = 0, u = !1;
    const i = t.node;
    t.node = function(f) {
      if (f.loc && f.loc.start && tr.has(f.type)) {
        const p = f.loc.start.line, g = f.loc.start.column - 1;
        (r.line !== p || r.column !== g) && (r.line = p, r.column = g, n.line = a, n.column = l, u && (u = !1, (n.line !== s.line || n.column !== s.column) && e.addMapping(o)), u = !0, e.addMapping({
          source: f.loc.source,
          original: r,
          generated: n
        }));
      }
      i.call(this, f), u && tr.has(f.type) && (s.line = a, s.column = l);
    };
    const c = t.emit;
    t.emit = function(f, p, g) {
      for (let m = 0; m < f.length; m++)
        f.charCodeAt(m) === 10 ? (a++, l = 0) : l++;
      c(f, p, g);
    };
    const h = t.result;
    return t.result = function() {
      return u && e.addMapping(o), {
        css: h(),
        map: e
      };
    }, t;
  }
  const ih = 43, oh = 45, Ve = (t, e) => {
    if (t === L && (t = e), typeof t == "string") {
      const n = t.charCodeAt(0);
      return n > 127 ? 32768 : n << 8;
    }
    return t;
  }, Zi = [
    [d, d],
    [d, A],
    [d, Q],
    [d, ot],
    [d, "-"],
    [d, x],
    [d, F],
    [d, $],
    [d, et],
    [d, I],
    [z, d],
    [z, A],
    [z, Q],
    [z, ot],
    [z, "-"],
    [z, x],
    [z, F],
    [z, $],
    [z, et],
    [N, d],
    [N, A],
    [N, Q],
    [N, ot],
    [N, "-"],
    [N, x],
    [N, F],
    [N, $],
    [N, et],
    [$, d],
    [$, A],
    [$, Q],
    [$, ot],
    [$, "-"],
    [$, x],
    [$, F],
    [$, $],
    [$, et],
    ["#", d],
    ["#", A],
    ["#", Q],
    ["#", ot],
    ["#", "-"],
    ["#", x],
    ["#", F],
    ["#", $],
    ["#", et],
    // https://github.com/w3c/csswg-drafts/pull/6874
    ["-", d],
    ["-", A],
    ["-", Q],
    ["-", ot],
    ["-", "-"],
    ["-", x],
    ["-", F],
    ["-", $],
    ["-", et],
    // https://github.com/w3c/csswg-drafts/pull/6874
    [x, d],
    [x, A],
    [x, Q],
    [x, ot],
    [x, x],
    [x, F],
    [x, $],
    [x, "%"],
    [x, et],
    // https://github.com/w3c/csswg-drafts/pull/6874
    ["@", d],
    ["@", A],
    ["@", Q],
    ["@", ot],
    ["@", "-"],
    ["@", et],
    // https://github.com/w3c/csswg-drafts/pull/6874
    [".", x],
    [".", F],
    [".", $],
    ["+", x],
    ["+", F],
    ["+", $],
    ["/", "*"]
  ], ah = Zi.concat([
    [d, N],
    [$, N],
    [N, N],
    [z, I],
    [z, wt],
    [z, X],
    [F, F],
    [F, $],
    [F, A],
    [F, "-"],
    [y, d],
    [y, A],
    [y, F],
    [y, $],
    [y, N],
    [y, "-"]
  ]);
  function to(t) {
    const e = new Set(
      t.map(([n, r]) => Ve(n) << 16 | Ve(r))
    );
    return function(n, r, s) {
      const o = Ve(r, s), a = s.charCodeAt(0);
      return (a === oh && r !== d && r !== A && r !== et || a === ih ? e.has(n << 16 | a << 8) : e.has(n << 16 | o)) && this.emit(" ", U, !0), o;
    };
  }
  const lh = to(Zi), eo = to(ah), er = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    safe: eo,
    spec: lh
  }, Symbol.toStringTag, { value: "Module" })), ch = 92;
  function uh(t, e) {
    if (typeof e == "function") {
      let n = null;
      t.children.forEach((r) => {
        n !== null && e.call(this, n), this.node(r), n = r;
      });
      return;
    }
    t.children.forEach(this.node, this);
  }
  function hh(t) {
    Qr(t, (e, n, r) => {
      this.token(e, t.slice(n, r));
    });
  }
  function fh(t) {
    const e = /* @__PURE__ */ new Map();
    for (let [n, r] of Object.entries(t.node))
      typeof (r.generate || r) == "function" && e.set(n, r.generate || r);
    return function(n, r) {
      let s = "", o = 0, a = {
        node(u) {
          if (e.has(u.type))
            e.get(u.type).call(l, u);
          else
            throw new Error("Unknown node type: " + u.type);
        },
        tokenBefore: eo,
        token(u, i) {
          o = this.tokenBefore(o, u, i), this.emit(i, u, !1), u === L && i.charCodeAt(0) === ch && this.emit(`
`, U, !0);
        },
        emit(u) {
          s += u;
        },
        result() {
          return s;
        }
      };
      r && (typeof r.decorator == "function" && (a = r.decorator(a)), r.sourceMap && (a = sh(a)), r.mode in er && (a.tokenBefore = er[r.mode]));
      const l = {
        node: (u) => a.node(u),
        children: uh,
        token: (u, i) => a.token(u, i),
        tokenize: hh
      };
      return a.node(n), a.result();
    };
  }
  const ph = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    AnPlusB: Xr,
    Atrule: Zr,
    AtrulePrelude: es,
    AttributeSelector: ss,
    Block: as,
    Brackets: cs,
    CDC: hs,
    CDO: ps,
    ClassSelector: gs,
    Combinator: ks,
    Comment: ys,
    Condition: xs,
    Declaration: As,
    DeclarationList: vs,
    Dimension: $s,
    Feature: Ls,
    FeatureFunction: Rs,
    FeatureRange: _s,
    Function: Ds,
    GeneralEnclosed: Ms,
    Hash: Bs,
    IdSelector: Hs,
    Identifier: Ws,
    Layer: Gs,
    LayerList: Ks,
    MediaQuery: Ys,
    MediaQueryList: Js,
    NestingSelector: ti,
    Nth: ni,
    Number: si,
    Operator: oi,
    Parentheses: li,
    Percentage: ui,
    PseudoClassSelector: fi,
    PseudoElementSelector: di,
    Ratio: mi,
    Raw: Si,
    Rule: bi,
    Scope: Ci,
    Selector: Ai,
    SelectorList: vi,
    String: Li,
    StyleSheet: Ri,
    SupportsDeclaration: _i,
    TypeSelector: Di,
    UnicodeRange: Bi,
    Url: zi,
    Value: Vi,
    WhiteSpace: qi
  }, Symbol.toStringTag, { value: "Module" })), dh = {
    node: ph
  }, gh = fh(dh);
  let Wt = null;
  class K {
    static createItem(e) {
      return {
        prev: null,
        next: null,
        data: e
      };
    }
    constructor() {
      this.head = null, this.tail = null, this.cursor = null;
    }
    createItem(e) {
      return K.createItem(e);
    }
    // cursor helpers
    allocateCursor(e, n) {
      let r;
      return Wt !== null ? (r = Wt, Wt = Wt.cursor, r.prev = e, r.next = n, r.cursor = this.cursor) : r = {
        prev: e,
        next: n,
        cursor: this.cursor
      }, this.cursor = r, r;
    }
    releaseCursor() {
      const { cursor: e } = this;
      this.cursor = e.cursor, e.prev = null, e.next = null, e.cursor = Wt, Wt = e;
    }
    updateCursors(e, n, r, s) {
      let { cursor: o } = this;
      for (; o !== null; )
        o.prev === e && (o.prev = n), o.next === r && (o.next = s), o = o.cursor;
    }
    *[Symbol.iterator]() {
      for (let e = this.head; e !== null; e = e.next)
        yield e.data;
    }
    // getters
    get size() {
      let e = 0;
      for (let n = this.head; n !== null; n = n.next)
        e++;
      return e;
    }
    get isEmpty() {
      return this.head === null;
    }
    get first() {
      return this.head && this.head.data;
    }
    get last() {
      return this.tail && this.tail.data;
    }
    // convertors
    fromArray(e) {
      let n = null;
      this.head = null;
      for (let r of e) {
        const s = K.createItem(r);
        n !== null ? n.next = s : this.head = s, s.prev = n, n = s;
      }
      return this.tail = n, this;
    }
    toArray() {
      return [...this];
    }
    toJSON() {
      return [...this];
    }
    // array-like methods
    forEach(e, n = this) {
      const r = this.allocateCursor(null, this.head);
      for (; r.next !== null; ) {
        const s = r.next;
        r.next = s.next, e.call(n, s.data, s, this);
      }
      this.releaseCursor();
    }
    forEachRight(e, n = this) {
      const r = this.allocateCursor(this.tail, null);
      for (; r.prev !== null; ) {
        const s = r.prev;
        r.prev = s.prev, e.call(n, s.data, s, this);
      }
      this.releaseCursor();
    }
    reduce(e, n, r = this) {
      let s = this.allocateCursor(null, this.head), o = n, a;
      for (; s.next !== null; )
        a = s.next, s.next = a.next, o = e.call(r, o, a.data, a, this);
      return this.releaseCursor(), o;
    }
    reduceRight(e, n, r = this) {
      let s = this.allocateCursor(this.tail, null), o = n, a;
      for (; s.prev !== null; )
        a = s.prev, s.prev = a.prev, o = e.call(r, o, a.data, a, this);
      return this.releaseCursor(), o;
    }
    some(e, n = this) {
      for (let r = this.head; r !== null; r = r.next)
        if (e.call(n, r.data, r, this))
          return !0;
      return !1;
    }
    map(e, n = this) {
      const r = new K();
      for (let s = this.head; s !== null; s = s.next)
        r.appendData(e.call(n, s.data, s, this));
      return r;
    }
    filter(e, n = this) {
      const r = new K();
      for (let s = this.head; s !== null; s = s.next)
        e.call(n, s.data, s, this) && r.appendData(s.data);
      return r;
    }
    nextUntil(e, n, r = this) {
      if (e === null)
        return;
      const s = this.allocateCursor(null, e);
      for (; s.next !== null; ) {
        const o = s.next;
        if (s.next = o.next, n.call(r, o.data, o, this))
          break;
      }
      this.releaseCursor();
    }
    prevUntil(e, n, r = this) {
      if (e === null)
        return;
      const s = this.allocateCursor(e, null);
      for (; s.prev !== null; ) {
        const o = s.prev;
        if (s.prev = o.prev, n.call(r, o.data, o, this))
          break;
      }
      this.releaseCursor();
    }
    // mutation
    clear() {
      this.head = null, this.tail = null;
    }
    copy() {
      const e = new K();
      for (let n of this)
        e.appendData(n);
      return e;
    }
    prepend(e) {
      return this.updateCursors(null, e, this.head, e), this.head !== null ? (this.head.prev = e, e.next = this.head) : this.tail = e, this.head = e, this;
    }
    prependData(e) {
      return this.prepend(K.createItem(e));
    }
    append(e) {
      return this.insert(e);
    }
    appendData(e) {
      return this.insert(K.createItem(e));
    }
    insert(e, n = null) {
      if (n !== null)
        if (this.updateCursors(n.prev, e, n, e), n.prev === null) {
          if (this.head !== n)
            throw new Error("before doesn't belong to list");
          this.head = e, n.prev = e, e.next = n, this.updateCursors(null, e);
        } else
          n.prev.next = e, e.prev = n.prev, n.prev = e, e.next = n;
      else
        this.updateCursors(this.tail, e, null, e), this.tail !== null ? (this.tail.next = e, e.prev = this.tail) : this.head = e, this.tail = e;
      return this;
    }
    insertData(e, n) {
      return this.insert(K.createItem(e), n);
    }
    remove(e) {
      if (this.updateCursors(e, e.prev, e, e.next), e.prev !== null)
        e.prev.next = e.next;
      else {
        if (this.head !== e)
          throw new Error("item doesn't belong to list");
        this.head = e.next;
      }
      if (e.next !== null)
        e.next.prev = e.prev;
      else {
        if (this.tail !== e)
          throw new Error("item doesn't belong to list");
        this.tail = e.prev;
      }
      return e.prev = null, e.next = null, e;
    }
    push(e) {
      this.insert(K.createItem(e));
    }
    pop() {
      return this.tail !== null ? this.remove(this.tail) : null;
    }
    unshift(e) {
      this.prepend(K.createItem(e));
    }
    shift() {
      return this.head !== null ? this.remove(this.head) : null;
    }
    prependList(e) {
      return this.insertList(e, this.head);
    }
    appendList(e) {
      return this.insertList(e);
    }
    insertList(e, n) {
      return e.head === null ? this : (n != null ? (this.updateCursors(n.prev, e.tail, n, e.head), n.prev !== null ? (n.prev.next = e.head, e.head.prev = n.prev) : this.head = e.head, n.prev = e.tail, e.tail.next = n) : (this.updateCursors(this.tail, e.tail, null, e.head), this.tail !== null ? (this.tail.next = e.head, e.head.prev = this.tail) : this.head = e.head, this.tail = e.tail), e.head = null, e.tail = null, this);
    }
    replace(e, n) {
      "head" in n ? this.insertList(n, e) : this.insert(n, e), this.remove(e);
    }
  }
  function mh(t, e) {
    const n = Object.create(SyntaxError.prototype), r = new Error();
    return Object.assign(n, {
      name: t,
      message: e,
      get stack() {
        return (r.stack || "").replace(/^(.+\n){1,3}/, `${t}: ${e}
`);
      }
    });
  }
  const Ge = 100, nr = 60, rr = "    ";
  function sr({ source: t, line: e, column: n, baseLine: r, baseColumn: s }, o) {
    function a(g, m) {
      return i.slice(g, m).map(
        (S, b) => String(g + b + 1).padStart(f) + " |" + S
      ).join(`
`);
    }
    const l = `
`.repeat(Math.max(r - 1, 0)), u = " ".repeat(Math.max(s - 1, 0)), i = (l + u + t).split(/\r\n?|\n|\f/), c = Math.max(1, e - o) - 1, h = Math.min(e + o, i.length + 1), f = Math.max(4, String(h).length) + 1;
    let p = 0;
    n += (rr.length - 1) * (i[e - 1].substr(0, n - 1).match(/\t/g) || []).length, n > Ge && (p = n - nr + 3, n = nr - 2);
    for (let g = c; g <= h; g++)
      g >= 0 && g < i.length && (i[g] = i[g].replace(/\t/g, rr), i[g] = (p > 0 && i[g].length > p ? "…" : "") + i[g].substr(p, Ge - 2) + (i[g].length > p + Ge - 1 ? "…" : ""));
    return [
      a(c, e),
      new Array(n + f + 2).join("-") + "^",
      a(e, h)
    ].filter(Boolean).join(`
`).replace(/^(\s+\d+\s+\|\n)+/, "").replace(/\n(\s+\d+\s+\|)+$/, "");
  }
  function ir(t, e, n, r, s, o = 1, a = 1) {
    return Object.assign(mh("SyntaxError", t), {
      source: e,
      offset: n,
      line: r,
      column: s,
      sourceFragment(u) {
        return sr({ source: e, line: r, column: s, baseLine: o, baseColumn: a }, isNaN(u) ? 0 : u);
      },
      get formattedMessage() {
        return `Parse error: ${t}
` + sr({ source: e, line: r, column: s, baseLine: o, baseColumn: a }, 2);
      }
    });
  }
  function kh(t) {
    const e = this.createList();
    let n = !1;
    const r = {
      recognizer: t
    };
    for (; !this.eof; ) {
      switch (this.tokenType) {
        case Y:
          this.next();
          continue;
        case U:
          n = !0, this.next();
          continue;
      }
      let s = t.getNode.call(this, r);
      if (s === void 0)
        break;
      n && (t.onWhiteSpace && t.onWhiteSpace.call(this, s, e, r), n = !1), e.push(s);
    }
    return n && t.onWhiteSpace && t.onWhiteSpace.call(this, null, e, r), e;
  }
  const or = () => {
  }, Sh = 33, yh = 35, qe = 59, ar = 123, lr = 0;
  function bh(t) {
    return function() {
      return this[t]();
    };
  }
  function Ke(t) {
    const e = /* @__PURE__ */ Object.create(null);
    for (const n of Object.keys(t)) {
      const r = t[n], s = r.parse || r;
      s && (e[n] = s);
    }
    return e;
  }
  function xh(t) {
    const e = {
      context: /* @__PURE__ */ Object.create(null),
      features: Object.assign(/* @__PURE__ */ Object.create(null), t.features),
      scope: Object.assign(/* @__PURE__ */ Object.create(null), t.scope),
      atrule: Ke(t.atrule),
      pseudo: Ke(t.pseudo),
      node: Ke(t.node)
    };
    for (const [n, r] of Object.entries(t.parseContext))
      switch (typeof r) {
        case "function":
          e.context[n] = r;
          break;
        case "string":
          e.context[n] = bh(r);
          break;
      }
    return W(W({
      config: e
    }, e), e.node);
  }
  function Ch(t) {
    let e = "", n = "<unknown>", r = !1, s = or, o = !1;
    const a = new na(), l = Object.assign(new ra(), xh(t || {}), {
      parseAtrulePrelude: !0,
      parseRulePrelude: !0,
      parseValue: !0,
      parseCustomProperty: !1,
      readSequence: kh,
      consumeUntilBalanceEnd: () => 0,
      consumeUntilLeftCurlyBracket(i) {
        return i === ar ? 1 : 0;
      },
      consumeUntilLeftCurlyBracketOrSemicolon(i) {
        return i === ar || i === qe ? 1 : 0;
      },
      consumeUntilExclamationMarkOrSemicolon(i) {
        return i === Sh || i === qe ? 1 : 0;
      },
      consumeUntilSemicolonIncluded(i) {
        return i === qe ? 2 : 0;
      },
      createList() {
        return new K();
      },
      createSingleNodeList(i) {
        return new K().appendData(i);
      },
      getFirstListNode(i) {
        return i && i.first;
      },
      getLastListNode(i) {
        return i && i.last;
      },
      parseWithFallback(i, c) {
        const h = this.tokenIndex;
        try {
          return i.call(this);
        } catch (f) {
          if (o)
            throw f;
          this.skip(h - this.tokenIndex);
          const p = c.call(this);
          return o = !0, s(f, p), o = !1, p;
        }
      },
      lookupNonWSType(i) {
        let c;
        do
          if (c = this.lookupType(i++), c !== U && c !== Y)
            return c;
        while (c !== lr);
        return lr;
      },
      charCodeAt(i) {
        return i >= 0 && i < e.length ? e.charCodeAt(i) : 0;
      },
      substring(i, c) {
        return e.substring(i, c);
      },
      substrToCursor(i) {
        return this.source.substring(i, this.tokenStart);
      },
      cmpChar(i, c) {
        return Vr(e, i, c);
      },
      cmpStr(i, c, h) {
        return Ee(e, i, c, h);
      },
      consume(i) {
        const c = this.tokenStart;
        return this.eat(i), this.substrToCursor(c);
      },
      consumeFunctionName() {
        const i = e.substring(this.tokenStart, this.tokenEnd - 1);
        return this.eat(A), i;
      },
      consumeNumber(i) {
        const c = e.substring(this.tokenStart, Gr(e, this.tokenStart));
        return this.eat(i), c;
      },
      eat(i) {
        if (this.tokenType !== i) {
          const c = Kr[i].slice(0, -6).replace(/-/g, " ").replace(/^./, (p) => p.toUpperCase());
          let h = `${/[[\](){}]/.test(c) ? `"${c}"` : c} is expected`, f = this.tokenStart;
          switch (i) {
            case d:
              this.tokenType === A || this.tokenType === Q ? (f = this.tokenEnd - 1, h = "Identifier is expected but function found") : h = "Identifier is expected";
              break;
            case N:
              this.isDelim(yh) && (this.next(), f++, h = "Name is expected");
              break;
            case F:
              this.tokenType === x && (f = this.tokenEnd, h = "Percent sign is expected");
              break;
          }
          this.error(h, f);
        }
        this.next();
      },
      eatIdent(i) {
        (this.tokenType !== d || this.lookupValue(0, i) === !1) && this.error(`Identifier "${i}" is expected`), this.next();
      },
      eatDelim(i) {
        this.isDelim(i) || this.error(`Delim "${String.fromCharCode(i)}" is expected`), this.next();
      },
      getLocation(i, c) {
        return r ? a.getLocationRange(
          i,
          c,
          n
        ) : null;
      },
      getLocationFromList(i) {
        if (r) {
          const c = this.getFirstListNode(i), h = this.getLastListNode(i);
          return a.getLocationRange(
            c !== null ? c.loc.start.offset - a.startOffset : this.tokenStart,
            h !== null ? h.loc.end.offset - a.startOffset : this.tokenStart,
            n
          );
        }
        return null;
      },
      error(i, c) {
        const h = typeof c != "undefined" && c < e.length ? a.getLocation(c) : this.eof ? a.getLocation(Zo(e, e.length - 1)) : a.getLocation(this.tokenStart);
        throw new ir(
          i || "Unexpected input",
          e,
          h.offset,
          h.line,
          h.column,
          a.startLine,
          a.startColumn
        );
      }
    });
    return Object.assign(function(i, c) {
      e = i, c = c || {}, l.setSource(e, Qr), a.setSource(
        e,
        c.offset,
        c.line,
        c.column
      ), n = c.filename || "<unknown>", r = !!c.positions, s = typeof c.onParseError == "function" ? c.onParseError : or, o = !1, l.parseAtrulePrelude = "parseAtrulePrelude" in c ? !!c.parseAtrulePrelude : !0, l.parseRulePrelude = "parseRulePrelude" in c ? !!c.parseRulePrelude : !0, l.parseValue = "parseValue" in c ? !!c.parseValue : !0, l.parseCustomProperty = "parseCustomProperty" in c ? !!c.parseCustomProperty : !1;
      const { context: h = "default", onComment: f } = c;
      if (!(h in l.context))
        throw new Error("Unknown context `" + h + "`");
      typeof f == "function" && l.forEachToken((g, m, S) => {
        if (g === Y) {
          const b = l.getLocation(m, S), C = Ee(e, S - 2, S, "*/") ? e.slice(m + 2, S - 2) : e.slice(m + 2, S);
          f(C, b);
        }
      });
      const p = l.context[h].call(l, c);
      return l.eof || l.error(), p;
    }, {
      SyntaxError: ir,
      config: l.config
    });
  }
  const wh = 35, Ah = 42, cr = 43, Th = 45, vh = 47, Eh = 117;
  function no(t) {
    switch (this.tokenType) {
      case N:
        return this.Hash();
      case ht:
        return this.Operator();
      case I:
        return this.Parentheses(this.readSequence, t.recognizer);
      case te:
        return this.Brackets(this.readSequence, t.recognizer);
      case wt:
        return this.String();
      case $:
        return this.Dimension();
      case F:
        return this.Percentage();
      case x:
        return this.Number();
      case A:
        return this.cmpStr(this.tokenStart, this.tokenEnd, "url(") ? this.Url() : this.Function(this.readSequence, t.recognizer);
      case Q:
        return this.Url();
      case d:
        return this.cmpChar(this.tokenStart, Eh) && this.cmpChar(this.tokenStart + 1, cr) ? this.UnicodeRange() : this.Identifier();
      case L: {
        const e = this.charCodeAt(this.tokenStart);
        if (e === vh || e === Ah || e === cr || e === Th)
          return this.Operator();
        e === wh && this.error("Hex or identifier is expected", this.tokenStart + 1);
        break;
      }
    }
  }
  const $h = {
    getNode: no
  }, Oh = 35, Lh = 38, Ph = 42, Rh = 43, Ih = 47, ur = 46, _h = 62, Nh = 124, Dh = 126;
  function Fh(t, e) {
    e.last !== null && e.last.type !== "Combinator" && t !== null && t.type !== "Combinator" && e.push({
      // FIXME: this.Combinator() should be used instead
      type: "Combinator",
      loc: null,
      name: " "
    });
  }
  function Mh() {
    switch (this.tokenType) {
      case te:
        return this.AttributeSelector();
      case N:
        return this.IdSelector();
      case X:
        return this.lookupType(1) === X ? this.PseudoElementSelector() : this.PseudoClassSelector();
      case d:
        return this.TypeSelector();
      case x:
      case F:
        return this.Percentage();
      case $:
        this.charCodeAt(this.tokenStart) === ur && this.error("Identifier is expected", this.tokenStart + 1);
        break;
      case L: {
        switch (this.charCodeAt(this.tokenStart)) {
          case Rh:
          case _h:
          case Dh:
          case Ih:
            return this.Combinator();
          case ur:
            return this.ClassSelector();
          case Ph:
          case Nh:
            return this.TypeSelector();
          case Oh:
            return this.IdSelector();
          case Lh:
            return this.NestingSelector();
        }
        break;
      }
    }
  }
  const jh = {
    onWhiteSpace: Fh,
    getNode: Mh
  };
  function Bh() {
    return this.createSingleNodeList(
      this.Raw(null, !1)
    );
  }
  function Uh() {
    const t = this.createList();
    if (this.skipSC(), t.push(this.Identifier()), this.skipSC(), this.tokenType === ht) {
      t.push(this.Operator());
      const e = this.tokenIndex, n = this.parseCustomProperty ? this.Value(null) : this.Raw(this.consumeUntilExclamationMarkOrSemicolon, !1);
      if (n.type === "Value" && n.children.isEmpty) {
        for (let r = e - this.tokenIndex; r <= 0; r++)
          if (this.lookupType(r) === U) {
            n.children.appendData({
              type: "WhiteSpace",
              loc: null,
              value: " "
            });
            break;
          }
      }
      t.push(n);
    }
    return t;
  }
  function hr(t) {
    return t !== null && t.type === "Operator" && (t.value[t.value.length - 1] === "-" || t.value[t.value.length - 1] === "+");
  }
  const Wh = {
    getNode: no,
    onWhiteSpace(t, e) {
      hr(t) && (t.value = " " + t.value), hr(e.last) && (e.last.value += " ");
    },
    expression: Bh,
    var: Uh
  }, zh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    AtrulePrelude: $h,
    Selector: jh,
    Value: Wh
  }, Symbol.toStringTag, { value: "Module" })), Hh = /* @__PURE__ */ new Set(["none", "and", "not", "or"]), Vh = {
    parse: {
      prelude() {
        const t = this.createList();
        if (this.tokenType === d) {
          const e = this.substring(this.tokenStart, this.tokenEnd);
          Hh.has(e.toLowerCase()) || t.push(this.Identifier());
        }
        return t.push(this.Condition("container")), t;
      },
      block(t = !1) {
        return this.Block(t);
      }
    }
  }, Gh = {
    parse: {
      prelude: null,
      block() {
        return this.Block(!0);
      }
    }
  };
  function Qe(t, e) {
    return this.parseWithFallback(
      () => {
        try {
          return t.call(this);
        } finally {
          this.skipSC(), this.lookupNonWSType(0) !== y && this.error();
        }
      },
      e || (() => this.Raw(null, !0))
    );
  }
  const fr = {
    layer() {
      this.skipSC();
      const t = this.createList(), e = Qe.call(this, this.Layer);
      return (e.type !== "Raw" || e.value !== "") && t.push(e), t;
    },
    supports() {
      this.skipSC();
      const t = this.createList(), e = Qe.call(
        this,
        this.Declaration,
        () => Qe.call(this, () => this.Condition("supports"))
      );
      return (e.type !== "Raw" || e.value !== "") && t.push(e), t;
    }
  }, qh = {
    parse: {
      prelude() {
        const t = this.createList();
        switch (this.tokenType) {
          case wt:
            t.push(this.String());
            break;
          case Q:
          case A:
            t.push(this.Url());
            break;
          default:
            this.error("String or url() is expected");
        }
        return this.skipSC(), this.tokenType === d && this.cmpStr(this.tokenStart, this.tokenEnd, "layer") ? t.push(this.Identifier()) : this.tokenType === A && this.cmpStr(this.tokenStart, this.tokenEnd, "layer(") && t.push(this.Function(null, fr)), this.skipSC(), this.tokenType === A && this.cmpStr(this.tokenStart, this.tokenEnd, "supports(") && t.push(this.Function(null, fr)), (this.lookupNonWSType(0) === d || this.lookupNonWSType(0) === I) && t.push(this.MediaQueryList()), t;
      },
      block: null
    }
  }, Kh = {
    parse: {
      prelude() {
        return this.createSingleNodeList(
          this.LayerList()
        );
      },
      block() {
        return this.Block(!1);
      }
    }
  }, Qh = {
    parse: {
      prelude() {
        return this.createSingleNodeList(
          this.MediaQueryList()
        );
      },
      block(t = !1) {
        return this.Block(t);
      }
    }
  }, Yh = {
    parse: {
      prelude() {
        return this.createSingleNodeList(
          this.SelectorList()
        );
      },
      block() {
        return this.Block(!0);
      }
    }
  }, Xh = {
    parse: {
      prelude() {
        return this.createSingleNodeList(
          this.SelectorList()
        );
      },
      block() {
        return this.Block(!0);
      }
    }
  }, Jh = {
    parse: {
      prelude() {
        return this.createSingleNodeList(
          this.Scope()
        );
      },
      block(t = !1) {
        return this.Block(t);
      }
    }
  }, Zh = {
    parse: {
      prelude: null,
      block(t = !1) {
        return this.Block(t);
      }
    }
  }, tf = {
    parse: {
      prelude() {
        return this.createSingleNodeList(
          this.Condition("supports")
        );
      },
      block(t = !1) {
        return this.Block(t);
      }
    }
  }, ef = {
    container: Vh,
    "font-face": Gh,
    import: qh,
    layer: Kh,
    media: Qh,
    nest: Yh,
    page: Xh,
    scope: Jh,
    "starting-style": Zh,
    supports: tf
  };
  function nf() {
    const t = this.createList();
    this.skipSC();
    t: for (; !this.eof; ) {
      switch (this.tokenType) {
        case d:
          t.push(this.Identifier());
          break;
        case wt:
          t.push(this.String());
          break;
        case ht:
          t.push(this.Operator());
          break;
        case y:
          break t;
        default:
          this.error("Identifier, string or comma is expected");
      }
      this.skipSC();
    }
    return t;
  }
  const Pt = {
    parse() {
      return this.createSingleNodeList(
        this.SelectorList()
      );
    }
  }, Ye = {
    parse() {
      return this.createSingleNodeList(
        this.Selector()
      );
    }
  }, rf = {
    parse() {
      return this.createSingleNodeList(
        this.Identifier()
      );
    }
  }, sf = {
    parse: nf
  }, me = {
    parse() {
      return this.createSingleNodeList(
        this.Nth()
      );
    }
  }, of = {
    dir: rf,
    has: Pt,
    lang: sf,
    matches: Pt,
    is: Pt,
    "-moz-any": Pt,
    "-webkit-any": Pt,
    where: Pt,
    not: Pt,
    "nth-child": me,
    "nth-last-child": me,
    "nth-last-of-type": me,
    "nth-of-type": me,
    slotted: Ye,
    host: Ye,
    "host-context": Ye
  }, af = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    AnPlusB: Yr,
    Atrule: Jr,
    AtrulePrelude: ts,
    AttributeSelector: rs,
    Block: os,
    Brackets: ls,
    CDC: us,
    CDO: fs,
    ClassSelector: ds,
    Combinator: ms,
    Comment: Ss,
    Condition: bs,
    Declaration: ws,
    DeclarationList: Ts,
    Dimension: Es,
    Feature: Os,
    FeatureFunction: Ps,
    FeatureRange: Is,
    Function: Ns,
    GeneralEnclosed: Fs,
    Hash: js,
    IdSelector: zs,
    Identifier: Us,
    Layer: Vs,
    LayerList: qs,
    MediaQuery: Qs,
    MediaQueryList: Xs,
    NestingSelector: Zs,
    Nth: ei,
    Number: ri,
    Operator: ii,
    Parentheses: ai,
    Percentage: ci,
    PseudoClassSelector: hi,
    PseudoElementSelector: pi,
    Ratio: gi,
    Raw: ki,
    Rule: yi,
    Scope: xi,
    Selector: wi,
    SelectorList: Ti,
    String: Oi,
    StyleSheet: Pi,
    SupportsDeclaration: Ii,
    TypeSelector: Ni,
    UnicodeRange: ji,
    Url: Wi,
    Value: Hi,
    WhiteSpace: Gi
  }, Symbol.toStringTag, { value: "Module" })), lf = {
    parseContext: {
      default: "StyleSheet",
      stylesheet: "StyleSheet",
      atrule: "Atrule",
      atrulePrelude(t) {
        return this.AtrulePrelude(t.atrule ? String(t.atrule) : null);
      },
      mediaQueryList: "MediaQueryList",
      mediaQuery: "MediaQuery",
      condition(t) {
        return this.Condition(t.kind);
      },
      rule: "Rule",
      selectorList: "SelectorList",
      selector: "Selector",
      block() {
        return this.Block(!0);
      },
      declarationList: "DeclarationList",
      declaration: "Declaration",
      value: "Value"
    },
    features: {
      supports: {
        selector() {
          return this.Selector();
        }
      },
      container: {
        style() {
          return this.Declaration();
        }
      }
    },
    scope: zh,
    atrule: ef,
    pseudo: of,
    node: af
  }, cf = Ch(lf);
  function Oe(t) {
    const e = {};
    for (const n of Object.keys(t)) {
      let r = t[n];
      r && (Array.isArray(r) || r instanceof K ? r = r.map(Oe) : r.constructor === Object && (r = Oe(r))), e[n] = r;
    }
    return e;
  }
  let uf = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", at = (t = 21) => {
    let e = "", n = t | 0;
    for (; n--; )
      e += uf[Math.random() * 64 | 0];
    return e;
  };
  const ro = at(), re = /* @__PURE__ */ new Set();
  function Le(t) {
    return !!(t && t.type === "Function" && t.name === "anchor");
  }
  function $t(t, e = !1) {
    return cf(t, {
      parseAtrulePrelude: !1,
      parseCustomProperty: !0,
      onParseError: (n) => {
        e && re.add(n);
      }
    });
  }
  function Z(t) {
    return gh(t, {
      // Default `safe` adds extra (potentially breaking) spaces for compatibility
      // with old browsers.
      mode: "spec"
    });
  }
  function hf(t) {
    return t.type === "Declaration";
  }
  function ff(t) {
    return t.toArray().reduce(
      (e, n) => n.type === "Operator" && n.value === "," ? (e.push([]), e) : (n.type === "Identifier" && e[e.length - 1].push(n), e),
      [[]]
    );
  }
  function un(t) {
    return t ? t.children.map((e) => {
      var s;
      let n;
      ((s = e.children.last) == null ? void 0 : s.type) === "PseudoElementSelector" && (e = Oe(e), n = Z(e.children.last), e.children.pop());
      const r = Z(e);
      return {
        selector: r + (n != null ? n : ""),
        elementPart: r,
        pseudoElementPart: n
      };
    }).toArray() : [];
  }
  function pf() {
    re.size > 0 && (console.group(
      `The CSS anchor positioning polyfill was not applied due to ${re.size === 1 ? "a CSS parse error" : "CSS parse errors"}.`
    ), re.forEach((t) => {
      console.warn(t.formattedMessage);
    }), console.groupEnd());
  }
  function df() {
    re.clear();
  }
  const hn = [
    ...Yi,
    "anchor-scope",
    "anchor-name"
  ].reduce(
    (t, e) => (t[e] = `--${e}-${ro}`, t),
    {}
  );
  function gf(t, e) {
    return hf(t) && hn[t.property] && e ? (e.children.appendData(q(W({}, t), {
      property: hn[t.property]
    })), { updated: !0 }) : {};
  }
  function mf(t) {
    for (const e of t) {
      let n = !1;
      const r = $t(e.css, !0);
      Et(r, {
        visit: "Declaration",
        enter(s) {
          var l;
          const o = (l = this.rule) == null ? void 0 : l.block, { updated: a } = gf(s, o);
          a && (n = !0);
        }
      }), n && (e.css = Z(r), e.changed = !0);
    }
    return t.some((e) => e.changed === !0);
  }
  var so = /* @__PURE__ */ ((t) => (t.All = "all", t.None = "none", t))(so || {});
  function it(t, e) {
    var r;
    return e = (r = hn[e]) != null ? r : e, (t instanceof HTMLElement ? getComputedStyle(t) : t.computedStyle).getPropertyValue(e).trim();
  }
  function Jt(t, e, n) {
    return it(t, e) === n;
  }
  function kf(t, { selector: e, pseudoElementPart: n }) {
    const r = getComputedStyle(t, n), s = document.createElement("div"), o = document.createElement("style");
    s.id = `fake-pseudo-element-${at()}`;
    for (const l of Array.from(r)) {
      const u = r.getPropertyValue(l);
      s.style.setProperty(l, u);
    }
    o.textContent += `#${s.id}${n} { content: ${r.content}; }`, o.textContent += `${e} { display: none !important; }`, document.head.append(o);
    const a = n === "::before" ? "afterbegin" : "beforeend";
    return t.insertAdjacentElement(a, s), { fakePseudoElement: s, sheet: o, computedStyle: r };
  }
  function Sf(t) {
    let e = t;
    for (; e; ) {
      if (Jt(e, "overflow", "scroll"))
        return e;
      e = e.parentElement;
    }
    return e;
  }
  function yf(t) {
    let e = Sf(t);
    return e === document.documentElement && (e = null), e != null ? e : { scrollTop: 0, scrollLeft: 0 };
  }
  function bf(t) {
    const { elementPart: e, pseudoElementPart: n } = t, r = [];
    if (n && !(n === "::before" || n === "::after")) return r;
    const a = Array.from(
      document.querySelectorAll(e)
    );
    if (!n)
      return r.push(...a), r;
    for (const l of a) {
      const { fakePseudoElement: u, sheet: i, computedStyle: c } = kf(
        l,
        t
      ), h = u.getBoundingClientRect(), { scrollY: f, scrollX: p } = globalThis, g = yf(l);
      r.push({
        fakePseudoElement: u,
        computedStyle: c,
        removeFakePseudoElement() {
          u.remove(), i.remove();
        },
        // For https://floating-ui.com/docs/autoupdate#ancestorscroll to work on
        // `VirtualElement`s.
        contextElement: l,
        // https://floating-ui.com/docs/virtual-elements
        getBoundingClientRect() {
          const { scrollY: m, scrollX: S } = globalThis, { scrollTop: b, scrollLeft: C } = g;
          return DOMRect.fromRect({
            y: h.y + (f - m) + (g.scrollTop - b),
            x: h.x + (p - S) + (g.scrollLeft - C),
            width: h.width,
            height: h.height
          });
        }
      });
    }
    return r;
  }
  function xf(t, e) {
    const n = it(t, "anchor-name");
    return e ? n.split(",").map((r) => r.trim()).includes(e) : !n;
  }
  function Cf(t, e) {
    const n = it(t, "anchor-scope");
    return n === e || n === "all";
  }
  const Tn = (t) => R(null, null, function* () {
    var n, r, s;
    let e = yield (n = H.getOffsetParent) == null ? void 0 : n.call(H, t);
    return (yield (r = H.isElement) == null ? void 0 : r.call(H, e)) || (e = (yield (s = H.getDocumentElement) == null ? void 0 : s.call(H, t)) || window.document.documentElement), e;
  }), pr = "InvalidMimeType";
  function wf(t) {
    return !!((t.type === "text/css" || t.rel === "stylesheet") && t.href);
  }
  function Af(t) {
    const e = new URL(t.href, document.baseURI);
    if (wf(t) && e.origin === location.origin)
      return e;
  }
  function Tf(t) {
    return R(this, null, function* () {
      return (yield Promise.all(
        t.map((n) => R(null, null, function* () {
          var r;
          if (!n.url)
            return n;
          if ((r = n.el) != null && r.disabled)
            return null;
          try {
            const s = yield fetch(n.url.toString()), o = s.headers.get("content-type");
            if (!(o != null && o.startsWith("text/css"))) {
              const l = new Error(
                `Error loading ${n.url}: expected content-type "text/css", got "${o}".`
              );
              throw l.name = pr, l;
            }
            const a = yield s.text();
            return q(W({}, n), { css: a });
          } catch (s) {
            if (s instanceof Error && s.name === pr)
              return console.warn(s), null;
            throw s;
          }
        }))
      )).filter((n) => n !== null);
    });
  }
  const dr = '[style*="anchor"]', gr = '[style*="position-area"]';
  function vf(t) {
    const e = t ? t.filter(
      (r) => r instanceof HTMLElement && (r.matches(dr) || r.matches(gr))
    ) : Array.from(
      document.querySelectorAll(
        [
          dr,
          gr
        ].join(",")
      )
    ), n = [];
    return e.filter((r) => r instanceof HTMLElement).forEach((r) => {
      const s = at(12), o = "data-has-inline-styles";
      r.setAttribute(o, s);
      const a = r.getAttribute("style"), l = `[${o}="${s}"] { ${a} }`;
      n.push({ el: r, css: l });
    }), n;
  }
  function Ef(t, e) {
    return R(this, null, function* () {
      const n = t != null ? t : Array.from(document.querySelectorAll("link, style")), r = [];
      n.filter((a) => a instanceof HTMLElement).forEach((a) => {
        if (a.tagName.toLowerCase() === "link") {
          const l = Af(a);
          l && r.push({ el: a, url: l });
        }
        a.tagName.toLowerCase() === "style" && r.push({ el: a, css: a.innerHTML });
      });
      const s = e ? t != null ? t : [] : void 0, o = vf(s);
      return yield Tf([...r, ...o]);
    });
  }
  const $f = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
  let io = (t = 21) => {
    let e = "", n = crypto.getRandomValues(new Uint8Array(t |= 0));
    for (; t--; )
      e += $f[n[t] & 63];
    return e;
  };
  const oo = "--pa-cascade-property", ao = "data-anchor-position-wrapper", lo = "data-pa-wrapper-for-", mr = "POLYFILL-POSITION-AREA", Of = [
    "left",
    "center",
    "right",
    "span-left",
    "span-right",
    "x-start",
    "x-end",
    "span-x-start",
    "span-x-end",
    "x-self-start",
    "x-self-end",
    "span-x-self-start",
    "span-x-self-end",
    "span-all",
    "top",
    "bottom",
    "span-top",
    "span-bottom",
    "y-start",
    "y-end",
    "span-y-start",
    "span-y-end",
    "y-self-start",
    "y-self-end",
    "span-y-self-start",
    "span-y-self-end",
    "block-start",
    "block-end",
    "span-block-start",
    "span-block-end",
    "inline-start",
    "inline-end",
    "span-inline-start",
    "span-inline-end",
    "self-block-start",
    "self-block-end",
    "span-self-block-start",
    "span-self-block-end",
    "self-inline-start",
    "self-inline-end",
    "span-self-inline-start",
    "span-self-inline-end",
    "start",
    "end",
    "span-start",
    "span-end",
    "self-start",
    "self-end",
    "span-self-start",
    "span-self-end"
  ];
  function co(t) {
    return Of.includes(t);
  }
  const kr = {
    left: [
      0,
      1,
      "Irrelevant"
      /* Irrelevant */
    ],
    center: [
      1,
      2,
      "Irrelevant"
      /* Irrelevant */
    ],
    right: [
      2,
      3,
      "Irrelevant"
      /* Irrelevant */
    ],
    "span-left": [
      0,
      2,
      "Irrelevant"
      /* Irrelevant */
    ],
    "span-right": [
      1,
      3,
      "Irrelevant"
      /* Irrelevant */
    ],
    "x-start": [
      0,
      1,
      "Physical"
      /* Physical */
    ],
    "x-end": [
      2,
      3,
      "Physical"
      /* Physical */
    ],
    "span-x-start": [
      0,
      2,
      "Physical"
      /* Physical */
    ],
    "span-x-end": [
      1,
      3,
      "Physical"
      /* Physical */
    ],
    "x-self-start": [
      0,
      1,
      "PhysicalSelf"
      /* PhysicalSelf */
    ],
    "x-self-end": [
      2,
      3,
      "PhysicalSelf"
      /* PhysicalSelf */
    ],
    "span-x-self-start": [
      0,
      2,
      "PhysicalSelf"
      /* PhysicalSelf */
    ],
    "span-x-self-end": [
      1,
      3,
      "PhysicalSelf"
      /* PhysicalSelf */
    ],
    "span-all": [
      0,
      3,
      "Irrelevant"
      /* Irrelevant */
    ],
    top: [
      0,
      1,
      "Irrelevant"
      /* Irrelevant */
    ],
    bottom: [
      2,
      3,
      "Irrelevant"
      /* Irrelevant */
    ],
    "span-top": [
      0,
      2,
      "Irrelevant"
      /* Irrelevant */
    ],
    "span-bottom": [
      1,
      3,
      "Irrelevant"
      /* Irrelevant */
    ],
    "y-start": [
      0,
      1,
      "Physical"
      /* Physical */
    ],
    "y-end": [
      2,
      3,
      "Physical"
      /* Physical */
    ],
    "span-y-start": [
      0,
      2,
      "Physical"
      /* Physical */
    ],
    "span-y-end": [
      1,
      3,
      "Physical"
      /* Physical */
    ],
    "y-self-start": [
      0,
      1,
      "PhysicalSelf"
      /* PhysicalSelf */
    ],
    "y-self-end": [
      2,
      3,
      "PhysicalSelf"
      /* PhysicalSelf */
    ],
    "span-y-self-start": [
      0,
      2,
      "PhysicalSelf"
      /* PhysicalSelf */
    ],
    "span-y-self-end": [
      1,
      3,
      "PhysicalSelf"
      /* PhysicalSelf */
    ],
    "block-start": [
      0,
      1,
      "Logical"
      /* Logical */
    ],
    "block-end": [
      2,
      3,
      "Logical"
      /* Logical */
    ],
    "span-block-start": [
      0,
      2,
      "Logical"
      /* Logical */
    ],
    "span-block-end": [
      1,
      3,
      "Logical"
      /* Logical */
    ],
    "inline-start": [
      0,
      1,
      "Logical"
      /* Logical */
    ],
    "inline-end": [
      2,
      3,
      "Logical"
      /* Logical */
    ],
    "span-inline-start": [
      0,
      2,
      "Logical"
      /* Logical */
    ],
    "span-inline-end": [
      1,
      3,
      "Logical"
      /* Logical */
    ],
    "self-block-start": [
      0,
      1,
      "LogicalSelf"
      /* LogicalSelf */
    ],
    "self-block-end": [
      2,
      3,
      "LogicalSelf"
      /* LogicalSelf */
    ],
    "span-self-block-start": [
      0,
      2,
      "LogicalSelf"
      /* LogicalSelf */
    ],
    "span-self-block-end": [
      1,
      3,
      "LogicalSelf"
      /* LogicalSelf */
    ],
    "self-inline-start": [
      0,
      1,
      "LogicalSelf"
      /* LogicalSelf */
    ],
    "self-inline-end": [
      2,
      3,
      "LogicalSelf"
      /* LogicalSelf */
    ],
    "span-self-inline-start": [
      0,
      2,
      "LogicalSelf"
      /* LogicalSelf */
    ],
    "span-self-inline-end": [
      1,
      3,
      "LogicalSelf"
      /* LogicalSelf */
    ],
    start: [
      0,
      1,
      "Logical"
      /* Logical */
    ],
    end: [
      2,
      3,
      "Logical"
      /* Logical */
    ],
    "span-start": [
      0,
      2,
      "Logical"
      /* Logical */
    ],
    "span-end": [
      1,
      3,
      "Logical"
      /* Logical */
    ],
    "self-start": [
      0,
      1,
      "LogicalSelf"
      /* LogicalSelf */
    ],
    "self-end": [
      2,
      3,
      "LogicalSelf"
      /* LogicalSelf */
    ],
    "span-self-start": [
      0,
      2,
      "LogicalSelf"
      /* LogicalSelf */
    ],
    "span-self-end": [
      1,
      3,
      "LogicalSelf"
      /* LogicalSelf */
    ]
  }, Lf = [
    "left",
    "center",
    "right",
    "span-left",
    "span-right",
    "x-start",
    "x-end",
    "span-x-start",
    "span-x-end",
    "x-self-start",
    "x-self-end",
    "span-x-self-start",
    "span-x-self-end",
    "span-all"
  ], Pf = [
    "top",
    "center",
    "bottom",
    "span-top",
    "span-bottom",
    "y-start",
    "y-end",
    "span-y-start",
    "span-y-end",
    "y-self-start",
    "y-self-end",
    "span-y-self-start",
    "span-y-self-end",
    "span-all"
  ], Rf = [
    "block-start",
    "center",
    "block-end",
    "span-block-start",
    "span-block-end",
    "span-all"
  ], If = [
    "inline-start",
    "center",
    "inline-end",
    "span-inline-start",
    "span-inline-end",
    "span-all"
  ], _f = [
    "self-block-start",
    "center",
    "self-block-end",
    "span-self-block-start",
    "span-self-block-end",
    "span-all"
  ], Nf = [
    "self-inline-start",
    "center",
    "self-inline-end",
    "span-self-inline-start",
    "span-self-inline-end",
    "span-all"
  ], Sr = [
    "start",
    "center",
    "end",
    "span-start",
    "span-end",
    "span-all"
  ], yr = [
    "self-start",
    "center",
    "self-end",
    "span-self-start",
    "span-self-end",
    "span-all"
  ], Df = ["block", "top", "bottom", "y"], Ff = ["inline", "left", "right", "x"];
  function fn(t) {
    const e = t.split("-");
    for (const n of e) {
      if (Df.includes(n)) return "block";
      if (Ff.includes(n)) return "inline";
    }
    return "ambiguous";
  }
  function Mf(t, e) {
    return e[0].includes(t[0]) && e[1].includes(t[1]) || e[0].includes(t[1]) && e[1].includes(t[0]);
  }
  const jf = [
    [Lf, Pf],
    [Rf, If],
    [_f, Nf],
    [Sr, Sr],
    [yr, yr]
  ];
  function Bf(t) {
    for (const e of jf)
      if (Mf(t, e)) return !0;
    return !1;
  }
  const br = (t) => {
    const e = getComputedStyle(t);
    return {
      writingMode: e.writingMode,
      direction: e.direction
    };
  }, Uf = (t, e) => R(null, null, function* () {
    const n = yield Tn(t);
    switch (e) {
      case "Logical":
      case "Physical":
        return br(n);
      case "LogicalSelf":
      case "PhysicalSelf":
        return br(t);
      default:
        return null;
    }
  }), Xe = (t) => t.reverse().map((e) => 3 - e), uo = (t, e) => t === "Irrelevant" ? e : t, Wf = (r, s) => R(null, [r, s], function* ({
    block: t,
    inline: e
  }, n) {
    const o = uo(t[2], e[2]), a = yield Uf(n, o), l = {
      block: [t[0], t[1]],
      inline: [e[0], e[1]]
    };
    if (a) {
      if (a.direction === "rtl" && (l.inline = Xe(l.inline)), a.writingMode.startsWith("vertical")) {
        const u = l.block;
        l.block = l.inline, l.inline = u;
      }
      if (a.writingMode.startsWith("sideways")) {
        const u = l.block;
        l.block = l.inline, l.inline = u, a.writingMode.endsWith("lr") && (l.block = Xe(l.block));
      }
      a.writingMode.endsWith("rl") && (l.inline = Xe(l.inline));
    }
    return l;
  }), zf = ({
    block: t,
    inline: e
  }) => {
    const n = [0, "top", "bottom", 0], r = [0, "left", "right", 0];
    return {
      block: [n[t[0]], n[t[1]]],
      inline: [r[e[0]], r[e[1]]]
    };
  };
  function xr([t, e]) {
    return t === 0 && e === 3 ? "center" : t === 0 ? "end" : e === 3 ? "start" : "center";
  }
  function Hf(t) {
    return t.type === "Declaration" && t.property === "position-area";
  }
  function Vf(t) {
    const e = t.value.children.toArray().map(({ name: n }) => n);
    return e.length === 1 && (fn(e[0]) === "ambiguous" ? e.push(e[0]) : e.push("span-all")), e;
  }
  function Gf(t) {
    if (!Hf(t)) return;
    const e = Vf(t);
    if (!Bf(e)) return;
    const n = {};
    switch (fn(e[0])) {
      case "block":
        n.block = e[0], n.inline = e[1];
        break;
      case "inline":
        n.inline = e[0], n.block = e[1];
        break;
      case "ambiguous":
        fn(e[1]) == "block" ? (n.block = e[1], n.inline = e[0]) : (n.inline = e[1], n.block = e[0]);
        break;
    }
    const r = {
      block: kr[n.block],
      inline: kr[n.inline]
    }, s = `--pa-declaration-${io(12)}`;
    return {
      values: n,
      grid: r,
      selectorUUID: s
    };
  }
  function qf(t, e) {
    [
      // Insets are applied to a wrapping element
      "justify-self",
      "align-self"
    ].forEach((n) => {
      e.children.appendData({
        type: "Declaration",
        property: n,
        value: { type: "Raw", value: `var(--pa-value-${n})` },
        important: !1
      });
    }), e.children.appendData({
      type: "Declaration",
      property: oo,
      value: { type: "Raw", value: t.selectorUUID },
      important: !1
    });
  }
  function Kf(t, e) {
    var r, s;
    let n;
    if (((r = t.parentElement) == null ? void 0 : r.tagName) === mr)
      n = t.parentElement;
    else {
      n = document.createElement(mr), n.style.display = "grid", n.style.position = "absolute";
      const o = getComputedStyle(t).pointerEvents;
      n.style.pointerEvents = "none", t.style.pointerEvents = o, ["top", "left", "right", "bottom"].forEach((a) => {
        n.style.setProperty(a, `var(--pa-value-${a})`);
      }), (s = t.parentElement) == null || s.insertBefore(n, t), n.appendChild(t);
    }
    return n.setAttribute(
      `${lo}${e}`,
      ""
    ), n;
  }
  function Qf(t, e, n) {
    return R(this, null, function* () {
      const r = `--pa-target-${io(12)}`, s = yield Wf(
        e.grid,
        t
      ), o = zf(s), a = uo(
        e.grid.block[2],
        e.grid.inline[2]
      ), l = [
        "LogicalSelf",
        "PhysicalSelf"
        /* PhysicalSelf */
      ].includes(a) ? s : e.grid, u = {
        block: xr([l.block[0], l.block[1]]),
        inline: xr([
          l.inline[0],
          l.inline[1]
        ])
      };
      return {
        insets: o,
        alignments: u,
        targetUUID: r,
        targetEl: t,
        anchorEl: n,
        wrapperEl: Kf(t, r),
        values: e.values,
        grid: e.grid,
        selectorUUID: e.selectorUUID
      };
    });
  }
  function Yf(t, e) {
    return `
    [${ao}="${e}"][${lo}${t}] {
      --pa-value-top: var(${t}-top);
      --pa-value-left: var(${t}-left);
      --pa-value-right: var(${t}-right);
      --pa-value-bottom: var(${t}-bottom);
      --pa-value-justify-self: var(${t}-justify-self);
      --pa-value-align-self: var(${t}-align-self);
    }
  `.replaceAll(`
`, "");
  }
  const Xf = [
    "normal",
    "most-width",
    "most-height",
    "most-block-size",
    "most-inline-size"
  ], Jf = [
    "flip-block",
    "flip-inline",
    "flip-start"
  ];
  function Zf(t) {
    return t.type === "Declaration";
  }
  function tp(t) {
    return t.type === "Declaration" && t.property === "position-try-fallbacks";
  }
  function ep(t) {
    return t.type === "Declaration" && t.property === "position-try-order";
  }
  function np(t) {
    return t.type === "Declaration" && t.property === "position-try";
  }
  function rp(t) {
    return t.type === "Atrule" && t.name === "position-try";
  }
  function sp(t) {
    return Jf.includes(t);
  }
  function ip(t) {
    return Xf.includes(t);
  }
  function op(t, e) {
    const n = document.querySelector(t);
    if (n) {
      let r = lp(n);
      return e.forEach((s) => {
        r = ho(r, s);
      }), r;
    }
  }
  function ap(t, e) {
    let n = t.declarations;
    return e.forEach((r) => {
      n = ho(n, r);
    }), n;
  }
  function lp(t) {
    const e = {};
    return Yi.forEach((n) => {
      const r = it(t, `--${n}-${ro}`);
      r && (e[n] = r);
    }), e;
  }
  const cp = {
    "flip-block": {
      top: "bottom",
      bottom: "top",
      "inset-block-start": "inset-block-end",
      "inset-block-end": "inset-block-start",
      "margin-top": "margin-bottom",
      "margin-bottom": "margin-top"
    },
    "flip-inline": {
      left: "right",
      right: "left",
      "inset-inline-start": "inset-inline-end",
      "inset-inline-end": "inset-inline-start",
      "margin-left": "margin-right",
      "margin-right": "margin-left"
    },
    "flip-start": {
      left: "top",
      right: "bottom",
      top: "left",
      bottom: "right",
      "inset-block-start": "inset-block-end",
      "inset-block-end": "inset-block-start",
      "inset-inline-start": "inset-inline-end",
      "inset-inline-end": "inset-inline-start",
      "inset-block": "inset-inline",
      "inset-inline": "inset-block"
    }
  }, up = {
    "flip-block": {
      top: "bottom",
      bottom: "top",
      start: "end",
      end: "start",
      "self-end": "self-start",
      "self-start": "self-end"
    },
    "flip-inline": {
      left: "right",
      right: "left",
      start: "end",
      end: "start",
      "self-end": "self-start",
      "self-start": "self-end"
    },
    "flip-start": {
      top: "left",
      left: "top",
      right: "bottom",
      bottom: "right"
    }
  }, hp = {
    "flip-block": {
      top: "bottom",
      bottom: "top",
      start: "end",
      end: "start"
    },
    "flip-inline": {
      left: "right",
      right: "left",
      start: "end",
      end: "start"
    },
    "flip-start": {
      // TODO: Requires fuller logic
    }
  };
  function fp(t, e) {
    return cp[e][t] || t;
  }
  function pp(t, e) {
    return up[e][t] || t;
  }
  function dp(t, e) {
    if (e === "flip-start")
      return t;
    {
      const n = hp[e];
      return t.split("-").map((r) => n[r] || r).join("-");
    }
  }
  function gp(t, e, n) {
    if (t === "margin") {
      const [r, s, o, a] = e.children.toArray();
      n === "flip-block" ? a ? e.children.fromArray([o, s, r, a]) : o && e.children.fromArray([o, s, r]) : n === "flip-inline" && a && e.children.fromArray([r, a, o, s]);
    } else if (t === "margin-block") {
      const [r, s] = e.children.toArray();
      n === "flip-block" && s && e.children.fromArray([s, r]);
    } else if (t === "margin-inline") {
      const [r, s] = e.children.toArray();
      n === "flip-inline" && s && e.children.fromArray([s, r]);
    }
  }
  const mp = (t, e) => {
    var s;
    return ((s = $t(`#id{${t}: ${e};}`).children.first) == null ? void 0 : s.block.children.first).value;
  };
  function ho(t, e) {
    const n = {};
    return Object.entries(t).forEach(([r, s]) => {
      var u;
      const o = r, a = mp(o, s), l = fp(o, e);
      l !== o && ((u = n[o]) != null || (n[o] = "revert")), Et(a, {
        visit: "Function",
        enter(i) {
          Le(i) && i.children.forEach((c) => {
            se(c) && Ji(c.name) && (c.name = pp(c.name, e));
          });
        }
      }), o === "position-area" && a.children.forEach((i) => {
        se(i) && co(i.name) && (i.name = dp(i.name, e));
      }), o.startsWith("margin") && gp(o, a, e), n[l] = Z(a);
    }), n;
  }
  function fo(t) {
    const e = ff(t), n = [];
    return e.forEach((r) => {
      const s = {
        atRules: [],
        tactics: [],
        positionAreas: []
      };
      r.forEach((o) => {
        sp(o.name) ? s.tactics.push(o.name) : o.name.startsWith("--") ? s.atRules.push(o.name) : co(o.name) && s.positionAreas.push(o.name);
      }), s.positionAreas.length ? n.push({
        positionArea: s.positionAreas[0],
        type: "position-area"
      }) : s.atRules.length && s.tactics.length ? n.push({
        tactics: s.tactics,
        atRule: s.atRules[0],
        type: "at-rule-with-try-tactic"
      }) : s.atRules.length ? n.push({
        atRule: s.atRules[0],
        type: "at-rule"
      }) : s.tactics.length && n.push({
        tactics: s.tactics,
        type: "try-tactic"
      });
    }), n;
  }
  function kp(t) {
    return tp(t) && t.value.children.first ? fo(t.value.children) : [];
  }
  function Sp(t) {
    if (np(t) && t.value.children.first) {
      const e = Oe(t);
      let n;
      const r = e.value.children.first.name;
      r && ip(r) && (n = r, e.value.children.shift());
      const s = fo(e.value.children);
      return { order: n, options: s };
    }
    return {};
  }
  function yp(t) {
    return ep(t) && t.value.children.first ? {
      order: t.value.children.first.name
    } : {};
  }
  function bp(t) {
    const { order: e, options: n } = Sp(t);
    if (e || n)
      return { order: e, options: n };
    const { order: r } = yp(t), s = kp(t);
    return r || s ? { order: r, options: s } : {};
  }
  function xp(t) {
    return le(t.property) || Ju(t.property) || Ki(t.property) || Zu(t.property) || ["position-anchor", "position-area"].includes(t.property);
  }
  function Cp(t) {
    var e, n;
    if (rp(t) && ((e = t.prelude) != null && e.value) && ((n = t.block) != null && n.children)) {
      const r = t.prelude.value, s = t.block.children.filter(
        (a) => Zf(a) && xp(a)
      ), o = {
        uuid: `${r}-try-${at(12)}`,
        declarations: Object.fromEntries(
          s.map((a) => [a.property, Z(a.value)])
        )
      };
      return { name: r, tryBlock: o };
    }
    return {};
  }
  function wp(t) {
    const e = {}, n = {}, r = {};
    for (const s of t) {
      const o = $t(s.css);
      Et(o, {
        visit: "Atrule",
        enter(a) {
          const { name: l, tryBlock: u } = Cp(a);
          l && u && (e[l] = u);
        }
      });
    }
    for (const s of t) {
      let o = !1;
      const a = /* @__PURE__ */ new Set(), l = $t(s.css);
      Et(l, {
        visit: "Declaration",
        enter(u) {
          var g;
          const i = (g = this.rule) == null ? void 0 : g.prelude, c = un(i);
          if (!c.length) return;
          const { order: h, options: f } = bp(u), p = {};
          h && (p.order = h), c.forEach(({ selector: m }) => {
            var S, b;
            f == null || f.forEach((C) => {
              var M, k, P;
              let v;
              if (C.type === "at-rule")
                v = C.atRule;
              else if (C.type === "try-tactic") {
                v = `${m}-${C.tactics.join("-")}`;
                const w = op(
                  m,
                  C.tactics
                );
                w && (e[v] = {
                  uuid: `${m}-${C.tactics.join("-")}-try-${at(12)}`,
                  declarations: w
                });
              } else if (C.type === "at-rule-with-try-tactic") {
                v = `${m}-${C.atRule}-${C.tactics.join("-")}`;
                const w = e[C.atRule], E = ap(
                  w,
                  C.tactics
                );
                E && (e[v] = {
                  uuid: `${m}-${C.atRule}-${C.tactics.join("-")}-try-${at(12)}`,
                  declarations: E
                });
              }
              if (v && e[v]) {
                const w = `[data-anchor-polyfill="${e[v].uuid}"]`;
                (M = n[w]) != null || (n[w] = []), n[w].push(m), a.has(v) || ((k = p.fallbacks) != null || (p.fallbacks = []), p.fallbacks.push(e[v]), a.add(v), (P = this.stylesheet) == null || P.children.prependData({
                  type: "Rule",
                  prelude: {
                    type: "Raw",
                    value: w
                  },
                  block: {
                    type: "Block",
                    children: new K().fromArray(
                      Object.entries(e[v].declarations).map(
                        ([E, _]) => ({
                          type: "Declaration",
                          important: !0,
                          property: E,
                          value: {
                            type: "Raw",
                            value: _
                          }
                        })
                      )
                    )
                  }
                }), o = !0);
              }
            }), Object.keys(p).length > 0 && (r[m] ? (p.order && (r[m].order = p.order), p.fallbacks && ((b = (S = r[m]).fallbacks) != null || (S.fallbacks = []), r[m].fallbacks.push(
              ...p.fallbacks
            ))) : r[m] = p);
          });
        }
      }), o && (s.css = Z(l), s.changed = !0);
    }
    return { fallbackTargets: n, validPositions: r };
  }
  function Ap(t, e) {
    return !t || t === e ? !1 : po(t) ? t.document.contains(e) : t.contains(e);
  }
  function po(t) {
    return !!(t && t === t.window);
  }
  function Tp(t) {
    return Jt(t, "position", "fixed");
  }
  function pn(t) {
    return !!(t && (Tp(t) || Jt(t, "position", "absolute")));
  }
  function Cr(t, e) {
    return t.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_FOLLOWING;
  }
  function vp(t) {
    return R(this, null, function* () {
      return yield H.getOffsetParent(t);
    });
  }
  function Je(t) {
    return R(this, null, function* () {
      if (!["absolute", "fixed"].includes(it(t, "position")))
        return yield vp(t);
      let e = t.parentElement;
      for (; e; ) {
        if (!Jt(e, "position", "static") && Jt(e, "display", "block"))
          return e;
        e = e.parentElement;
      }
      return window;
    });
  }
  function Ep(t, e, n, r) {
    return R(this, null, function* () {
      const s = yield Je(t), o = yield Je(n);
      if (!(Ap(o, t) || po(o)) || s === o && !(!pn(t) || Cr(t, n)))
        return !1;
      if (s !== o) {
        let a;
        const l = [];
        for (a = s; a && a !== o && a !== window; )
          l.push(a), a = yield Je(a);
        const u = l[l.length - 1];
        if (u instanceof HTMLElement && !(!pn(u) || Cr(u, n)))
          return !1;
      }
      {
        let a = t.parentElement;
        for (; a; ) {
          if (Jt(a, "content-visibility", "hidden"))
            return !1;
          a = a.parentElement;
        }
      }
      return !(e && r && wr(t, e, r) !== wr(n, e, r));
    });
  }
  function wr(t, e, n) {
    for (; !(t.matches(n) && Cf(t, e)); ) {
      if (!t.parentElement)
        return null;
      t = t.parentElement;
    }
    return t;
  }
  function $p(t, e, n, r) {
    return R(this, null, function* () {
      if (!(t instanceof HTMLElement && n.length && pn(t)))
        return null;
      const s = n.flatMap(bf).filter((a) => xf(a, e)), o = r.map((a) => a.selector).join(",") || null;
      for (let a = s.length - 1; a >= 0; a--) {
        const l = s[a], u = "fakePseudoElement" in l;
        if (yield Ep(
          u ? l.fakePseudoElement : l,
          e,
          t,
          o
        ))
          return u && l.removeFakePseudoElement(), l;
      }
      return null;
    });
  }
  function Op(t) {
    return t.type === "Declaration" && t.property === "anchor-name";
  }
  function Lp(t) {
    return t.type === "Declaration" && t.property === "anchor-scope";
  }
  function dn(t) {
    return !!(t && t.type === "Function" && t.name === "anchor-size");
  }
  function Ce(t) {
    return !!(t && t.type === "Function" && t.name === "var");
  }
  function se(t) {
    return !!(t.type === "Identifier" && t.name);
  }
  function Pp(t) {
    return !!(t.type === "Percentage" && t.value);
  }
  function Ar(t, e) {
    let n, r, s, o = "", a = !1, l;
    const u = [];
    t.children.toArray().forEach((f) => {
      if (a) {
        o = `${o}${Z(f)}`;
        return;
      }
      if (f.type === "Operator" && f.value === ",") {
        a = !0;
        return;
      }
      u.push(f);
    });
    let [i, c] = u;
    if (c || (c = i, i = void 0), i && (se(i) && i.name.startsWith("--") ? n = i.name : Ce(i) && i.children.first && (l = i.children.first.name)), c)
      if (Le(t)) {
        if (se(c) && Ji(c.name))
          r = c.name;
        else if (Pp(c)) {
          const f = Number(c.value);
          r = Number.isNaN(f) ? void 0 : f;
        }
      } else dn(t) && se(c) && rh(c.name) && (s = c.name);
    const h = `--anchor-${at(12)}`;
    return Object.assign(t, {
      type: "Raw",
      value: `var(${h})`,
      children: null
    }), Reflect.deleteProperty(t, "name"), {
      anchorName: n,
      anchorSide: r,
      anchorSize: s,
      fallbackValue: o || "0px",
      customPropName: l,
      uuid: h
    };
  }
  function Tr(t) {
    return t.value.children.map(({ name: e }) => e);
  }
  let Ht = {}, vt = {}, _t = {}, ie = {}, It = {};
  function Rp() {
    Ht = {}, vt = {}, _t = {}, ie = {}, It = {};
  }
  function Ip(t, e) {
    var n;
    if ((Le(t) || dn(t)) && e) {
      if (e.property.startsWith("--")) {
        const r = Z(e.value), s = Ar(t);
        return ie[s.uuid] = r, _t[e.property] = [
          ...(n = _t[e.property]) != null ? n : [],
          s
        ], { changed: !0 };
      }
      if (Le(t) && le(e.property) || dn(t) && Xi(e.property)) {
        const r = Ar(t);
        return { prop: e.property, data: r, changed: !0 };
      }
    }
    return {};
  }
  function vr(t, e) {
    return R(this, null, function* () {
      let n = e == null ? void 0 : e.anchorName;
      const r = e == null ? void 0 : e.customPropName;
      if (t && !n) {
        const l = it(
          t,
          "position-anchor"
        );
        l ? n = l : r && (n = it(t, r));
      }
      const s = n ? Ht[n] || [] : [], o = n ? vt[so.All] || [] : [], a = n ? vt[n] || [] : [];
      return yield $p(
        t,
        n || null,
        s,
        [...o, ...a]
      );
    });
  }
  function _p(t) {
    return R(this, null, function* () {
      var c, h, f, p, g, m, S, b, C, v, M;
      const e = {}, n = {};
      Rp();
      const { fallbackTargets: r, validPositions: s } = wp(t);
      for (const k of t) {
        let P = !1;
        const w = $t(k.css);
        Et(w, function(E) {
          var J, bt, Lt, xt, ft, Ct;
          const _ = (J = this.rule) == null ? void 0 : J.prelude, O = un(_);
          if (Op(E) && O.length)
            for (const B of Tr(E))
              (bt = Ht[B]) != null || (Ht[B] = []), Ht[B].push(...O);
          if (Lp(E) && O.length)
            for (const B of Tr(E))
              (Lt = vt[B]) != null || (vt[B] = []), vt[B].push(...O);
          const {
            prop: T,
            data: j,
            changed: D
          } = Ip(E, this.declaration);
          if (T && j && O.length)
            for (const { selector: B } of O)
              e[B] = q(W({}, e[B]), {
                [T]: [...(ft = (xt = e[B]) == null ? void 0 : xt[T]) != null ? ft : [], j]
              });
          let V;
          if (this.block && (V = Gf(E), V)) {
            qf(
              V,
              this.block
            );
            for (const { selector: B } of O)
              n[B] = [
                ...(Ct = n[B]) != null ? Ct : [],
                V
              ];
          }
          (D || V) && (P = !0);
        }), P && (k.css = Z(w), k.changed = !0);
      }
      const o = new Set(Object.keys(_t)), a = {}, l = (k) => {
        var E, _, O, T, j;
        const P = [], w = new Set((_ = (E = a[k]) == null ? void 0 : E.names) != null ? _ : []);
        for (; w.size > 0; )
          for (const D of w)
            P.push(...(O = _t[D]) != null ? O : []), w.delete(D), (j = (T = a[D]) == null ? void 0 : T.names) != null && j.length && a[D].names.forEach((V) => w.add(V));
        return P;
      };
      for (; o.size > 0; ) {
        const k = [];
        for (const P of t) {
          let w = !1;
          const E = $t(P.css);
          Et(E, {
            visit: "Function",
            enter(_) {
              var D, V;
              const O = (D = this.rule) == null ? void 0 : D.prelude, T = this.declaration, j = T == null ? void 0 : T.property;
              if ((O == null ? void 0 : O.children.isEmpty) === !1 && Ce(_) && T && j && _.children.first && o.has(_.children.first.name) && // For now, we only want assignments to other CSS custom properties
              j.startsWith("--")) {
                const J = _.children.first, bt = (V = _t[J.name]) != null ? V : [], Lt = l(J.name);
                if (!(bt.length || Lt.length))
                  return;
                const xt = `${J.name}-anchor-${at(12)}`, ft = Z(T.value);
                ie[xt] = ft, a[j] || (a[j] = { names: [], uuids: [] });
                const Ct = a[j];
                Ct.names.includes(J.name) || Ct.names.push(J.name), Ct.uuids.push(xt), k.push(j), J.name = xt, w = !0;
              }
            }
          }), w && (P.css = Z(E), P.changed = !0);
        }
        o.clear(), k.forEach((P) => o.add(P));
      }
      for (const k of t) {
        let P = !1;
        const w = $t(k.css);
        Et(w, {
          visit: "Function",
          enter(E) {
            var j, D, V, J, bt, Lt, xt;
            const _ = (j = this.rule) == null ? void 0 : j.prelude, O = this.declaration, T = O == null ? void 0 : O.property;
            if ((_ == null ? void 0 : _.children.isEmpty) === !1 && Ce(E) && O && T && E.children.first && // Now we only want assignments to inset/sizing properties
            (le(T) || Ki(T))) {
              const ft = E.children.first, Ct = (D = _t[ft.name]) != null ? D : [], B = l(ft.name);
              if (!(Ct.length || B.length))
                return;
              const he = `${T}-${at(12)}`;
              if (B.length) {
                const Mt = /* @__PURE__ */ new Set([ft.name]);
                for (; Mt.size > 0; )
                  for (const jt of Mt) {
                    const G = a[jt];
                    if ((V = G == null ? void 0 : G.names) != null && V.length && ((J = G == null ? void 0 : G.uuids) != null && J.length))
                      for (const Bt of G.names)
                        for (const Ut of G.uuids)
                          It[Ut] = q(W({}, It[Ut]), {
                            // - `key` (`propUuid`) is the property-specific
                            //   uuid to append to the new custom property name
                            // - `value` is the new property-specific custom
                            //   property value to use
                            [he]: `${Bt}-${he}`
                          });
                    Mt.delete(jt), (bt = G == null ? void 0 : G.names) != null && bt.length && G.names.forEach((Bt) => Mt.add(Bt));
                  }
              }
              const go = un(_);
              for (const Mt of [...Ct, ...B]) {
                const jt = W({}, Mt), G = `--anchor-${at(12)}-${T}`, Bt = jt.uuid;
                jt.uuid = G;
                for (const { selector: Ut } of go)
                  e[Ut] = q(W({}, e[Ut]), {
                    [T]: [...(xt = (Lt = e[Ut]) == null ? void 0 : Lt[T]) != null ? xt : [], jt]
                  });
                It[Bt] = q(W({}, It[Bt]), {
                  // - `key` (`propUuid`) is the property-specific
                  //   uuid to append to the new custom property name
                  // - `value` is the new property-specific custom
                  //   property value to use
                  [he]: G
                });
              }
              ft.name = `${ft.name}-${he}`, P = !0;
            }
          }
        }), P && (k.css = Z(w), k.changed = !0);
      }
      if (Object.keys(It).length > 0)
        for (const k of t) {
          let P = !1;
          const w = $t(k.css);
          Et(w, {
            visit: "Function",
            enter(E) {
              var _, O, T, j;
              if (Ce(E) && ((O = (_ = E.children.first) == null ? void 0 : _.name) != null && O.startsWith("--")) && ((j = (T = this.declaration) == null ? void 0 : T.property) != null && j.startsWith("--")) && this.block) {
                const D = E.children.first, V = It[D.name];
                if (V)
                  for (const [J, bt] of Object.entries(V))
                    this.block.children.appendData({
                      type: "Declaration",
                      important: !1,
                      property: `${this.declaration.property}-${J}`,
                      value: {
                        type: "Raw",
                        value: Z(this.declaration.value).replace(
                          `var(${D.name})`,
                          `var(${bt})`
                        )
                      }
                    }), P = !0;
                ie[D.name] && (this.declaration.value = {
                  type: "Raw",
                  value: ie[D.name]
                }, P = !0);
              }
            }
          }), P && (k.css = Z(w), k.changed = !0);
        }
      const u = /* @__PURE__ */ new Map();
      for (const [k, P] of Object.entries(e)) {
        let w;
        k.startsWith("[data-anchor-polyfill=") && ((c = r[k]) != null && c.length) ? w = document.querySelectorAll(r[k].join(",")) : w = document.querySelectorAll(k);
        for (const [E, _] of Object.entries(P))
          for (const O of _)
            for (const T of w) {
              const j = yield vr(T, O), D = `--anchor-${at(12)}`;
              u.set(T, q(W({}, (h = u.get(T)) != null ? h : {}), {
                [O.uuid]: D
              })), T.setAttribute(
                "style",
                `${O.uuid}: var(${D}); ${(f = T.getAttribute("style")) != null ? f : ""}`
              ), s[k] = q(W({}, s[k]), {
                declarations: q(W({}, (p = s[k]) == null ? void 0 : p.declarations), {
                  [E]: [
                    ...(S = (m = (g = s[k]) == null ? void 0 : g.declarations) == null ? void 0 : m[E]) != null ? S : [],
                    q(W({}, O), { anchorEl: j, targetEl: T, uuid: D })
                  ]
                })
              });
            }
      }
      const i = {
        el: document.createElement("link"),
        changed: !1,
        created: !0,
        css: ""
      };
      t.push(i);
      for (const [k, P] of Object.entries(n)) {
        const w = document.querySelectorAll(k);
        for (const E of w) {
          const _ = yield vr(E);
          for (const O of P) {
            const T = yield Qf(
              E,
              O,
              _
            );
            i.css += Yf(
              T.targetUUID,
              O.selectorUUID
            ), i.changed = !0, s[k] = q(W({}, s[k]), {
              declarations: q(W({}, (b = s[k]) == null ? void 0 : b.declarations), {
                "position-area": [
                  ...(M = (v = (C = s[k]) == null ? void 0 : C.declarations) == null ? void 0 : v["position-area"]) != null ? M : [],
                  T
                ]
              })
            });
          }
        }
      }
      return { rules: s, inlineStyles: u, anchorScopes: vt };
    });
  }
  const Np = [
    "as",
    "blocking",
    "crossorigin",
    // 'disabled' is not relevant for style elements, but this exclusion is
    // theoretical, as a <link rel=stylesheet disabled> will not be loaded, and
    // will not reach this part of the polyfill. See #246.
    "disabled",
    "fetchpriority",
    "href",
    "hreflang",
    "integrity",
    "referrerpolicy",
    "rel",
    "type"
  ];
  function Er(t, e, n = !1) {
    const r = [];
    for (const { el: s, css: o, changed: a, created: l = !1 } of t) {
      const u = { el: s, css: o, changed: !1 };
      if (a) {
        if (s.tagName.toLowerCase() === "style")
          s.innerHTML = o;
        else if (s instanceof HTMLLinkElement) {
          const i = document.createElement("style");
          i.textContent = o;
          for (const c of s.getAttributeNames())
            if (!c.startsWith("on") && !Np.includes(c)) {
              const h = s.getAttribute(c);
              h !== null && i.setAttribute(c, h);
            }
          s.hasAttribute("href") && i.setAttribute("data-original-href", s.getAttribute("href")), l ? (i.setAttribute("data-generated-by-polyfill", "true"), document.head.insertAdjacentElement("beforeend", i)) : (s.insertAdjacentElement("beforebegin", i), s.remove()), u.el = i;
        } else if (s.hasAttribute("data-has-inline-styles")) {
          const i = s.getAttribute("data-has-inline-styles");
          if (i) {
            const c = `[data-has-inline-styles="${i}"]{`;
            let f = o.slice(c.length, 0 - "}".length);
            const p = e == null ? void 0 : e.get(s);
            if (p)
              for (const [g, m] of Object.entries(p))
                f = `${g}: var(${m}); ${f}`;
            s.setAttribute("style", f);
          }
        }
      }
      n && s.hasAttribute("data-has-inline-styles") && s.removeAttribute("data-has-inline-styles"), r.push(u);
    }
    return r;
  }
  const Dp = q(W({}, H), { _c: /* @__PURE__ */ new Map() }), Fp = (t, e) => {
    let n;
    switch (t) {
      case "start":
      case "self-start":
        n = 0;
        break;
      case "end":
      case "self-end":
        n = 100;
        break;
      default:
        typeof t == "number" && !Number.isNaN(t) && (n = t);
    }
    if (n !== void 0)
      return e ? 100 - n : n;
  }, Mp = (t, e) => {
    let n;
    switch (t) {
      case "block":
      case "self-block":
        n = e ? "width" : "height";
        break;
      case "inline":
      case "self-inline":
        n = e ? "height" : "width";
        break;
    }
    return n;
  }, $r = (t) => {
    switch (t) {
      case "top":
      case "bottom":
        return "y";
      case "left":
      case "right":
        return "x";
    }
    return null;
  }, jp = (t) => {
    switch (t) {
      case "x":
        return "width";
      case "y":
        return "height";
    }
    return null;
  }, Or = (t) => it(t, "display") === "inline", Lr = (t, e) => (e === "x" ? ["border-left-width", "border-right-width"] : ["border-top-width", "border-bottom-width"]).reduce(
    (r, s) => r + parseInt(it(t, s), 10),
    0
  ) || 0, ke = (t, e) => parseInt(it(t, `margin-${e}`), 10) || 0, Bp = (t) => ({
    top: ke(t, "top"),
    right: ke(t, "right"),
    bottom: ke(t, "bottom"),
    left: ke(t, "left")
  }), Ze = (a) => R(null, [a], function* ({
    targetEl: t,
    targetProperty: e,
    anchorRect: n,
    anchorSide: r,
    anchorSize: s,
    fallback: o = null
  }) {
    var l;
    if (!((s || r !== void 0) && t && n))
      return o;
    if (s) {
      if (!Xi(e))
        return o;
      let u;
      switch (s) {
        case "width":
        case "height":
          u = s;
          break;
        default: {
          let i = !1;
          const c = it(t, "writing-mode");
          i = c.startsWith("vertical-") || c.startsWith("sideways-"), u = Mp(s, i);
        }
      }
      return u ? `${n[u]}px` : o;
    }
    if (r !== void 0) {
      let u, i;
      const c = $r(e);
      if (!(le(e) && c && (!le(r) || c === $r(r))))
        return o;
      const h = ["top", "left"];
      switch (r) {
        case "left":
        case "top":
          u = 0;
          break;
        case "right":
        case "bottom":
          u = 100;
          break;
        case "center":
          u = 50;
          break;
        case "inside":
          u = h.includes(e) ? 0 : 100;
          break;
        case "outside":
          u = h.includes(e) ? 100 : 0;
          break;
        default:
          if (t) {
            const g = (yield (l = H.isRTL) == null ? void 0 : l.call(H, t)) || !1;
            u = Fp(r, g);
          }
      }
      const f = typeof u == "number" && !Number.isNaN(u), p = jp(c);
      if (f && p) {
        (e === "bottom" || e === "right") && (i = yield Tn(t));
        let g = n[c] + n[p] * (u / 100);
        switch (e) {
          case "bottom": {
            if (!i)
              break;
            let m = i.clientHeight;
            if (m === 0 && Or(i)) {
              const S = Lr(i, c);
              m = i.offsetHeight - S;
            }
            g = m - g;
            break;
          }
          case "right": {
            if (!i)
              break;
            let m = i.clientWidth;
            if (m === 0 && Or(i)) {
              const S = Lr(i, c);
              m = i.offsetWidth - S;
            }
            g = m - g;
            break;
          }
        }
        return `${g}px`;
      }
    }
    return o;
  }), Up = (t) => "wrapperEl" in t, Wp = (t) => "uuid" in t;
  function zp(t, e = !1) {
    return R(this, null, function* () {
      const n = document.documentElement;
      for (const [r, s] of Object.entries(t))
        for (const o of s) {
          const a = o.anchorEl, l = o.targetEl;
          if (a && l)
            if (Up(o)) {
              const u = o.wrapperEl, i = (c, h, f) => R(null, null, function* () {
                return c === 0 ? "0px" : yield Ze({
                  targetEl: u,
                  targetProperty: h,
                  anchorRect: f,
                  anchorSide: c
                });
              });
              nn(
                a,
                u,
                () => R(null, null, function* () {
                  const c = it(
                    l,
                    oo
                  );
                  u.setAttribute(ao, c);
                  const h = yield H.getElementRects({
                    reference: a,
                    floating: u,
                    strategy: "absolute"
                  }), f = o.insets, p = yield i(
                    f.block[0],
                    "top",
                    h.reference
                  ), g = yield i(
                    f.block[1],
                    "bottom",
                    h.reference
                  ), m = yield i(
                    f.inline[0],
                    "left",
                    h.reference
                  ), S = yield i(
                    f.inline[1],
                    "right",
                    h.reference
                  );
                  n.style.setProperty(
                    `${o.targetUUID}-top`,
                    p || null
                  ), n.style.setProperty(
                    `${o.targetUUID}-left`,
                    m || null
                  ), n.style.setProperty(
                    `${o.targetUUID}-right`,
                    S || null
                  ), n.style.setProperty(
                    `${o.targetUUID}-bottom`,
                    g || null
                  ), n.style.setProperty(
                    `${o.targetUUID}-justify-self`,
                    o.alignments.inline
                  ), n.style.setProperty(
                    `${o.targetUUID}-align-self`,
                    o.alignments.block
                  );
                }),
                { animationFrame: e }
              );
            } else
              nn(
                a,
                l,
                () => R(null, null, function* () {
                  const u = yield H.getElementRects({
                    reference: a,
                    floating: l,
                    strategy: "absolute"
                  }), i = yield Ze({
                    targetEl: l,
                    targetProperty: r,
                    anchorRect: u.reference,
                    anchorSide: o.anchorSide,
                    anchorSize: o.anchorSize,
                    fallback: o.fallbackValue
                  });
                  n.style.setProperty(o.uuid, i);
                }),
                { animationFrame: e }
              );
          else if (Wp(o)) {
            const u = yield Ze({
              targetProperty: r,
              anchorSide: o.anchorSide,
              anchorSize: o.anchorSize,
              fallback: o.fallbackValue
            });
            n.style.setProperty(o.uuid, u);
          }
        }
    });
  }
  function Pr(t, e) {
    return R(this, null, function* () {
      const n = yield H.getElementRects({
        reference: t,
        floating: t,
        strategy: "absolute"
      });
      return yield Wo(
        {
          x: t.offsetLeft,
          y: t.offsetTop,
          platform: Dp,
          rects: n,
          elements: {
            floating: t,
            reference: e
          },
          strategy: "absolute"
        },
        {
          padding: Bp(t)
        }
      );
    });
  }
  function Hp(t, e, n = !1) {
    return R(this, null, function* () {
      if (!e.length)
        return;
      const r = document.querySelectorAll(t);
      for (const s of r) {
        let o = !1;
        const a = yield Tn(s);
        nn(
          // We're just checking whether the target element overflows, so we don't
          // care about the position of the anchor element in this case. Passing in
          // an empty object instead of a reference element avoids unnecessarily
          // watching for irrelevant changes.
          {},
          s,
          () => R(null, null, function* () {
            if (o)
              return;
            o = !0, s.removeAttribute("data-anchor-polyfill");
            const l = yield Pr(s, a);
            if (Object.values(l).every((u) => u <= 0)) {
              s.removeAttribute("data-anchor-polyfill-last-successful"), o = !1;
              return;
            }
            for (const [u, { uuid: i }] of e.entries()) {
              s.setAttribute("data-anchor-polyfill", i);
              const c = yield Pr(s, a);
              if (Object.values(c).every((h) => h <= 0)) {
                s.setAttribute("data-anchor-polyfill-last-successful", i), o = !1;
                break;
              }
              if (u === e.length - 1) {
                const h = s.getAttribute(
                  "data-anchor-polyfill-last-successful"
                );
                h ? s.setAttribute("data-anchor-polyfill", h) : s.removeAttribute("data-anchor-polyfill"), o = !1;
                break;
              }
            }
          }),
          { animationFrame: n, layoutShift: !1 }
        );
      }
    });
  }
  function Vp(t, e = !1) {
    return R(this, null, function* () {
      var n, r;
      for (const s of Object.values(t))
        yield zp((n = s.declarations) != null ? n : {}, e);
      for (const [s, o] of Object.entries(t))
        yield Hp(
          s,
          (r = o.fallbacks) != null ? r : [],
          e
        );
    });
  }
  function Gp(t = {}) {
    const e = typeof t == "boolean" ? { useAnimationFrame: t } : t, n = e.useAnimationFrame === void 0 ? !!window.UPDATE_ANCHOR_ON_ANIMATION_FRAME : e.useAnimationFrame;
    return Array.isArray(e.elements) || (e.elements = void 0), Object.assign(e, { useAnimationFrame: n });
  }
  function Rr(t) {
    return R(this, null, function* () {
      const e = Gp(
        window.ANCHOR_POSITIONING_POLYFILL_OPTIONS
      );
      let n = yield Ef(e.elements, e.excludeInlineStyles), r = {}, s;
      df();
      try {
        mf(n) && (n = Er(n));
        const a = yield _p(n);
        r = a.rules, s = a.inlineStyles;
      } catch (o) {
        throw pf(), o;
      }
      return Object.values(r).length && (Er(n, s, !0), yield Vp(r, e.useAnimationFrame)), r;
    });
  }
  document.readyState !== "complete" ? window.addEventListener("load", () => {
    Rr();
  }) : Rr();
});
export default qp();
//# sourceMappingURL=css-anchor-positioning.js.map